const de = {
  // ─── Common ───
  common: {
    loading: "Lädt...",
    back: "Zurück",
    next: "Weiter",
    save: "Speichern",
    cancel: "Abbrechen",
    close: "Schließen",
    send: "Senden",
    submit: "Absenden",
    yes: "Ja",
    no: "Nein",
    error: "Fehler",
    success: "Erfolg",
    search: "Suchen",
    more: "Mehr",
    less: "Weniger",
    optional: "optional",
    required: "Pflichtfeld",
    perMonth: "/ Monat",
    oneTime: "einmalig",
    free: "Kostenlos",
    skip: "Überspringen",
    pleaseWait: "Bitte warten...",
    backToHome: "Zurück zur Startseite",
    learnMore: "Mehr erfahren",
    email: "E-Mail",
    phone: "Telefon",
    password: "Passwort",
    name: "Name",
    selected: "ausgewählt",
    available: "verfügbar",
    used: "genutzt",
    of: "von",
    question: "Frage",
    craftBusiness: "Handwerksbetrieb",
    forCraftBusinesses: "Für Handwerksbetriebe",
    home: "Startseite",
    projectInquiry: "Projektanfrage",
    projectInquiries: "Projektanfragen",
  },
  // ─── Header ───
  header: {
    dashboard: "Dashboard",
    signOut: "Abmelden",
    completeProfile: "Profil vervollständigen",
    submitInquiry: "Projektanfrage stellen",
    signIn: "Anmelden",
    menuOpen: "Menü öffnen",
    menuClose: "Menü schließen",
    registerAsCraft: "Als Handwerksbetrieb registrieren",
  },
  // ─── Footer ───
  footer: {
    tagline: "Qualifizierte Projektanfragen.\nFür ausgewählte Handwerksbetriebe.",
    motto: "Finden · Verbinden · Bauen",
    platform: "Plattform",
    findCraft: "Handwerksbetrieb finden",
    submitInquiry: "Projektanfrage stellen",
    forCraftBusinesses: "Für Handwerksbetriebe",
    aboutUs: "Über uns",
    legalAndContact: "Rechtliches & Kontakt",
    imprint: "Impressum",
    privacy: "Datenschutz",
    accessibility: "Barrierefreiheit",
    contact: "Kontakt",
    copyright: "© {{year}} CRAFTFINDUS. Für Handwerksbetriebe in Deutschland, Österreich und der Schweiz.",
  },
  // ─── Cookie Banner ───
  cookies: {
    title: "Wir verwenden Cookies",
    description: "Wir nutzen Cookies, um Ihnen die bestmögliche Nutzung unserer Website zu ermöglichen. Weitere Informationen finden Sie in unserer",
    privacyLink: "Datenschutzerklärung",
    acceptAll: "Alle akzeptieren",
    configure: "Konfigurieren",
    saveSelection: "Auswahl speichern",
    onlyNecessary: "Nur notwendige",
    necessary: "Notwendig",
    necessaryDesc: "Für den Betrieb der Website erforderlich.",
    analytics: "Analyse",
    analyticsDesc: "Helfen uns, die Nutzung der Website zu verstehen.",
    marketing: "Marketing",
    marketingDesc: "Ermöglichen personalisierte Werbung.",
  },
  // ─── Mobile CTA ───
  mobileCta: {
    submitInquiry: "Projektanfrage stellen",
    craftBusiness: "Handwerksbetrieb",
  },
  // ─── Floating Phone ───
  floatingPhone: {
    question: "Sie haben Fragen? Rufen Sie uns gerne an:",
    ariaLabel: "Telefonnummer anzeigen",
  },
  // ─── Home (Index) ───
  home: {
    seoTitle: "Geprüfte Handwerksbetriebe finden – Qualitätsvermittlung",
    seoDesc: "CRAFTFINDUS: Die Qualitätsplattform für Handwerksvermittlung. Geprüfte Betriebe, transparente Prozesse, faire Abrechnung. 3-5 passende Fachbetriebe pro Projekt.",
    heroLabel: "Qualitätsgeprüfte Handwerksvermittlung",
    heroTitle1: "Geprüfte Handwerker.",
    heroTitle2: "Echte Projekte.",
    heroTitle3: "Transparente Vermittlung.",
    heroDesc: "Nur qualifizierte Anfragen – fair, strukturiert und ohne Chaos. Wir finden 3 bis 5 geprüfte Fachbetriebe für Ihr Projekt.",
    heroCta: "Passende Betriebe jetzt finden",
    heroCtaCraft: "Ich bin Handwerksbetrieb",
    badge100Free: "100% kostenlos für Auftraggeber",
    badgeResponse: "Antwort in <24h",
    badgeVerified: "Nur geprüfte Fachbetriebe",
    tradesLabel: "Ihr Projekt, unser Netzwerk",
    tradesTitle: "Finden Sie den richtigen Handwerker für jedes Gewerk",
    tradesDesc: "Egal ob Reparatur, Neubau oder Sanierung – {{brand}} findet den passenden Betrieb in Ihrer Nähe.",
    tradesCta: "Projekt professionell starten",
    electrician: "Elektriker",
    electricianDesc: "Elektroinstallation, Beleuchtung, Sicherungskästen, Smart Home – finden Sie einen Elektriker in Ihrer Nähe.",
    plumbing: "Sanitär & Heizung",
    plumbingDesc: "Bad-Renovierung, Heizungsaustausch, Rohrleitungen – professionelle Installateure für Ihr Projekt.",
    roofing: "Dachdecker & Zimmerer",
    roofingDesc: "Dachsanierung, Dachfenster, Dachstuhl – erfahrene Dachdecker für sichere Lösungen.",
    painting: "Maler & Bodenleger",
    paintingDesc: "Fassadenanstrich, Tapezieren, Bodenbeläge – kreative Handwerker für schöne Räume.",
    solar: "Photovoltaik & Klima",
    solarDesc: "Solaranlagen, Wärmepumpen, Klimaanlagen – nachhaltige Energielösungen vom Fachbetrieb.",
    construction: "Bauunternehmen & Innenausbau",
    constructionDesc: "Trockenbau, Fliesenarbeiten, Komplettsanierung – alles aus einer Hand.",
    howLabel: "3 einfache Schritte",
    howTitle: "So finden Sie den passenden Handwerker",
    howDesc: "Kein langes Suchen. Keine endlosen Telefonate. Wir führen Sie durch den Prozess.",
    step1Title: "Projekt beschreiben",
    step1Desc: "Beantworten Sie ein paar einfache Fragen \u2013 z.\u00A0B. \u201EBad renovieren\u201C oder \u201EPhotovoltaik-Anlage installieren\u201C.",
    step2Title: "Handwerker werden ausgewählt",
    step2Desc: "{{brand}} findet durch intelligentes Matching automatisch bis zu 5 Handwerksbetriebe, die zu Ihrem Projekt passen. Aus Ihrer Region, mit der richtigen Erfahrung.",
    step3Title: "Sie werden kontaktiert",
    step3Desc: "Die ausgewählten Betriebe melden sich direkt bei Ihnen, persönlich, nicht per Massenmail. Sie entscheiden, wer am besten passt.",
    benefitsLabel: "Vorteile",
    benefitsTitle: "Eine Plattform, zwei Gewinner",
    forClients: "Für Auftraggeber",
    clientsTitle: "Handwerker finden: einfach & kostenlos",
    clientFree: "Komplett kostenlos",
    clientFreeDesc: "Keine Gebühren, keine Provision. Sie bezahlen nur Ihren Handwerker.",
    clientNoJargon: "Kein Fach-Jargon nötig",
    clientNoJargonDesc: "Beschreiben Sie Ihr Projekt in eigenen Worten. Wir finden die richtigen Gewerke.",
    clientFast: "Schnelle Antworten",
    clientFastDesc: "In unter 24 Stunden melden sich 3 bis 5 passende Handwerksbetriebe bei Ihnen.",
    clientQuality: "Geprüfte Qualität",
    clientQualityDesc: "Alle Betriebe sind verifiziert. Meisterbetriebe werden besonders hervorgehoben.",
    clientCta: "Projekt professionell starten",
    forProviders: "Für Handwerksbetriebe",
    providersTitle: "Qualifizierte Projekte – keine Billig-Anfragen",
    providerMatched: "Vorqualifizierte Projekte",
    providerMatchedDesc: "Jede Anfrage wird geprüft: Budget bestätigt, Kontaktdaten verifiziert, Projektbeschreibung vorhanden.",
    providerCompetitors: "Max. 3 bis 5 Mitbewerber",
    providerCompetitorsDesc: "Keine Massenplattform. Faire Chancen durch intelligente Limitierung.",
    providerTransparent: "Transparente Abrechnung",
    providerTransparentDesc: "Feste Preise pro Kontakt. Kein Bieten, keine Provisionen. Sie wissen vorher, was Sie zahlen.",
    providerRate: "Fairer Reklamationsprozess",
    providerRateDesc: "Nicht erreichbar? Falsches Gewerk? Sie erhalten Ihren Kontaktpreis zurück. Garantiert.",
    providerCta: "Mehr qualifizierte Projekte sichern",
    principlesTitle: "Warum {{brand}}?",
    principle1Num: "01",
    principle1Title: "Kein Suchen, kein Vergleichen",
    principle1Desc: "Wir zeigen keine endlosen Listen. Unser Algorithmus wählt die passenden Betriebe für Sie aus – basierend auf Daten, nicht Zufall.",
    principle2Num: "02",
    principle2Title: "Qualität statt Masse",
    principle2Desc: "Maximal 3 bis 5 Handwerksbetriebe pro Projekt. So bekommen Sie echte Aufmerksamkeit, kein Copy-Paste-Angebot.",
    principle3Num: "03",
    principle3Title: "Transparent & fair",
    principle3Desc: "Jeder weiß, warum ein Match zustande kommt. Kein Bieten, kein Preisdumping. Faire Bedingungen für beide Seiten.",
    statsTitle: "{{brand}} in Zahlen",
    stat1Value: "87%",
    stat1Label: "Erfolgsquote bei Projektvergabe",
    stat2Value: "3-5",
    stat2Label: "Geprüfte Betriebe pro Projekt",
    stat3Value: "<24h",
    stat3Label: "Durchschnittliche Reaktionszeit",
    stat4Value: "0 €",
    stat4Label: "Kosten für Auftraggeber",
    trustArchLabel: "Unser Qualitätsversprechen",
    trustArchTitle: "Warum CRAFTFINDUS anders ist",
    trustArch1Title: "Verifizierungsprozess",
    trustArch1Desc: "Jeder Betrieb wird geprüft: Gewerbeanmeldung, Versicherung, Bonität. Nur verifizierte Betriebe erhalten Projektanfragen.",
    trustArch2Title: "Lead-Qualitätsprüfung",
    trustArch2Desc: "Jede Anfrage durchläuft unsere Qualitäts-Engine. Nur Anfragen mit Score > 60 werden an Betriebe weitergeleitet.",
    trustArch3Title: "Fairness-Mechanismus",
    trustArch3Desc: "Max. 3-5 Betriebe pro Projekt. Feste Preise. Reklamation bei unqualifizierten Kontakten – Erstattung garantiert.",
    trustArch4Title: "Transparente Abrechnung",
    trustArch4Desc: "Keine versteckten Gebühren, keine Provisionen. Sie sehen vorher, was ein Kontakt kostet.",
    faqLabel: "FAQ",
    faqTitle: "Häufig gestellte Fragen",
    faqDesc: "Antworten für Auftraggeber und Handwerksbetriebe.",
    faqForClients: "Für Auftraggeber",
    faqForProviders: "Für Handwerksbetriebe",
    faqC1Q: "Ich brauche einen Handwerker, weiß aber nicht genau welches Gewerk. Ist CRAFTFINDUS das Richtige?",
    faqC1A: "Ja, absolut! CRAFTFINDUS ist genau dafür gemacht. Beschreiben Sie einfach Ihr Projekt in der geführten Anfrage – wir finden das passende Gewerk und die richtigen Betriebe für Sie. Komplett kostenlos.",
    faqC2Q: "Was kostet es, wenn ich einen Handwerker suche?",
    faqC2A: "Für Sie als Auftraggeber ist CRAFTFINDUS komplett kostenlos. Sie stellen Ihre Projektanfrage, erhalten 3 bis 5 passende Handwerksbetriebe und entscheiden selbst, mit wem Sie zusammenarbeiten. Keine versteckten Kosten.",
    faqC3Q: "Wie schnell bekomme ich Antworten auf meine Projektanfrage?",
    faqC3A: "In der Regel melden sich qualifizierte Handwerksbetriebe innerhalb von 24 Stunden bei Ihnen. Bei dringenden Anfragen oft sogar schneller. Sie erhalten maximal 3 bis 5 Angebote – handverlesen, keine Massenantworten.",
    faqC4Q: "Welche Projekte kann ich über CRAFTFINDUS anfragen?",
    faqC4A: "Praktisch alle Handwerksprojekte: Elektroinstallation, Sanitär, Heizung, Dach, Innenausbau, Photovoltaik, Klimaanlagen, Malerarbeiten und vieles mehr. Egal ob kleine Reparatur oder großes Bauprojekt.",
    faqP1Q: "Was bringt mir CRAFTFINDUS als Handwerksbetrieb?",
    faqP1A: "Sie erhalten vorqualifizierte Projektanfragen, die zu Ihrem Gewerk und Ihrer Region passen. Maximal 3 bis 5 Betriebe pro Anfrage bedeutet: weniger Wettbewerb, höhere Abschlussquoten, kein Preiskampf.",
    faqP2Q: "Wie funktioniert das Matching bei CRAFTFINDUS?",
    faqP2A: "Unser Algorithmus analysiert jede Projektanfrage und gleicht sie mit Ihrem Profil ab: Gewerk, Spezialisierung, Region, Verfügbarkeit und Projektgröße. Nur bei hoher Passung erhalten Sie die Anfrage.",
    faqP3Q: "Was kostet CRAFTFINDUS für Handwerksbetriebe?",
    faqP3A: "Sie zahlen nur pro angenommener Projektanfrage einen transparenten, festen Preis. Keine monatlichen Gebühren, keine Provisionen auf Ihre Aufträge. Sie entscheiden selbst, welche Projekte Sie annehmen.",
    faqP4Q: "Was unterscheidet CRAFTFINDUS von anderen Handwerker-Portalen?",
    faqP4A: "Kein Bieten, kein Preisdumping, keine Vergleichsportal-Mechanik. Bei CRAFTFINDUS werden Handwerksbetriebe ausgewählt, nicht gesucht. Die Limitierung auf 3 bis 5 Betriebe pro Anfrage sichert faire Chancen.",
    ctaLabel: "Jetzt starten",
    ctaTitle: "Was trifft auf Sie zu?",
    ctaClientTitle: "Ich suche einen Handwerker",
    ctaClientDesc: "Beschreiben Sie Ihr Projekt. Wir finden kostenlos die passenden Handwerksbetriebe für Sie.",
    ctaClientBtn: "Projekt professionell starten",
    ctaProviderTitle: "Ich bin Handwerksbetrieb",
    ctaProviderDesc: "Keine Billig-Anfragen. Nur qualifizierte Projekte mit verifizierten Kontaktdaten und bestätigtem Budget.",
    ctaProviderBtn: "Mehr qualifizierte Projekte sichern",
    socialProof: "Bereits über 500 Projekte erfolgreich vermittelt — 97% Weiterempfehlungsrate",
    proofVerified: "Verifizierte Betriebe",
    proofDsgvo: "DSGVO-konform",
    proofResponse: "Ø 4h Antwortzeit",
  },
  // ─── Auth ───
  auth: {
    seoTitle: "Anmelden – Handwerksbetrieb Portal",
    seoDesc: "Melden Sie sich bei CRAFTFINDUS an – dem exklusiven Portal für qualifizierte Handwerksbetriebe.",
    backToHome: "Zurück zur Startseite",
    loginPrompt: "Melden Sie sich in Ihrem Account an",
    emailLabel: "E-Mail",
    emailPlaceholder: "ihre@email.de",
    passwordLabel: "Passwort",
    passwordPlaceholder: "••••••••",
    loginBtn: "Anmelden",
    invalidCredentials: "Ungültige Anmeldedaten. Bitte überprüfen Sie Ihre Eingaben.",
    alreadyRegistered: "Diese E-Mail-Adresse ist bereits registriert.",
    registrationSuccess: "Registrierung erfolgreich! Bitte bestätigen Sie Ihre E-Mail.",
    loginSuccess: "Erfolgreich angemeldet",
    invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    passwordMin: "Passwort muss mindestens 6 Zeichen haben",
  },
  // ─── Dashboard ───
  dashboard: {
    title: "Projektanfragen",
    subtitle: "Qualifizierte Projektanfragen für Ihren Betrieb",
    tabNew: "Neu",
    tabInReview: "In Prüfung",
    tabCompleted: "Abgeschlossen",
    tabPayment: "Zahlung & Abrechnung",
    tabProfile: "Profil",
    noNew: "Keine neuen Projektanfragen",
    noInReview: "Keine laufenden Projektanfragen",
    noCompleted: "Keine abgeschlossenen Projektanfragen",
    selectForDetails: "Wählen Sie eine Projektanfrage\nfür Details",
    weeklyLimitReached: "Wochenlimit erreicht",
    paymentMissing: "Zahlungsmittel fehlt",
    paymentMissingDesc: "Projektanfragen werden erst nach Hinterlegung freigeschaltet.",
    setupPayment: "Jetzt hinterlegen →",
    paymentRequired: "Bitte zuerst ein Zahlungsmittel hinterlegen",
    subscriptionBlocked: "Abo gesperrt – bitte Zahlung unter Abrechnung abschließen",
    quotaExhausted: "Kontingent erreicht – Add-on kaufen oder Plan upgraden",
    acceptError: "Fehler beim Annehmen",
    accepted: "Projektanfrage angenommen",
    declined: "Projektanfrage abgelehnt",
    declineError: "Fehler beim Ablehnen",
    questionSent: "Rückfrage gesendet",
    completed: "Projektanfrage abgeschlossen",
    completeError: "Fehler beim Abschließen",
  },
  // ─── Onboarding ───
  onboarding: {
    progressCompany: "Betrieb",
    progressTradesRegion: "Gewerke & Region",
    progressConfig: "Konfiguration",
    companyTitle: "Ihr Betrieb",
    companySubtitle: "Grundlegende Informationen für Ihr Profil",
    companyName: "Betriebsname",
    companyNamePlaceholder: "Ihr Handwerksbetrieb",
    contactPerson: "Ansprechpartner",
    contactPersonPlaceholder: "Max Mustermann",
    masterCraftsman: "Meisterbetrieb",
    masterCraftsmanDesc: "Ihr Betrieb ist ein eingetragener Meisterbetrieb",
    tradesTitle: "Ihre Gewerke",
    tradesSubtitle: "Welche Gewerke decken Sie ab?",
    regionTitle: "Ihr Standort",
    regionSubtitle: "Wo ist Ihr Betrieb ansässig?",
    regionLabel: "Region / PLZ",
    regionPlaceholder: "z.B. München, 80331",
    radiusTitle: "Einsatzradius",
    radiusSubtitle: "Wie weit fahren Sie zu Kunden?",
    limitTitle: "Projektanfragen-Limit",
    limitSubtitle: "Wie viele Anfragen möchten Sie pro Woche erhalten?",
    limitFocused: "Fokussiert",
    limitStandard: "Standard",
    limitIntensive: "Intensiv",
    completeTitle: "Betriebsprofil speichern",
    summaryCompany: "Betrieb",
    summaryTrades: "Gewerke",
    summaryMaster: "Meisterbetrieb",
    summaryRadius: "Einsatzradius",
    summaryLimit: "Limit",
    summaryPerWeek: "pro Woche",
    saveProfile: "Betriebsprofil speichern",
    saving: "Wird gespeichert...",
    profileCreated: "Betriebsprofil erstellt",
    saveError: "Fehler beim Speichern",
    veryNear: "Sehr nah",
    nearCity: "Stadtnah",
    regional: "Regional",
    wide: "Weiträumig",
    superRegional: "Überregional",
  },
  // ─── Inquiry ───
  inquiry: {
    seoTitle: "Projektanfrage stellen – Qualifizierte Handwerksbetriebe finden",
    seoDesc: "Projektanfrage stellen bei CRAFTFINDUS: Beschreiben Sie Ihr Projekt und wir finden bis zu 5 qualifizierte Handwerksbetriebe aus Ihrer Region.",
    tradeElektriker: "Elektriker",
    tradeSanitaer: "Sanitär",
    tradeHeizung: "Heizung",
    tradeDachdecker: "Dachdecker",
    tradeInnenausbau: "Innenausbau",
    tradeSchreiner: "Schreiner",
    tradeBauunternehmen: "Bauunternehmen",
    tradeFensterbauer: "Fensterbauer",
    tradeGartenbau: "Gartenbau",
    tradePhotovoltaik: "Photovoltaik",
    tradeKlimaanlagen: "Klimaanlagen",
    tradeMalerbetrieb: "Malerbetrieb",
    progressDetails: "Projektdetails",
    progressDescription: "Beschreibung",
    progressContact: "Kontakt",
    questionOf: "Frage {{current}} von {{total}}",
    tradeTitle: "Welches Projekt möchten Sie umsetzen?",
    tradeSubtitle: "Je genauer Ihre Auswahl, desto passender werden die Fachbetriebe.",
    tradesLoading: "Gewerke werden geladen...",
    projectTypeTitle: "Art des Projekts",
    projectTypeSubtitle: "Was soll gemacht werden?",
    repair: "Reparatur",
    repairDesc: "Bestehende Schäden beheben",
    newBuild: "Neubau",
    newBuildDesc: "Neues Gebäude oder Anbau",
    renovation: "Sanierung",
    renovationDesc: "Bestehendes renovieren",
    installation: "Installation",
    installationDesc: "Neue Anlage oder System einbauen",
    objectTypeTitle: "Art des Objekts",
    objectTypeSubtitle: "Um welches Gebäude handelt es sich?",
    efh: "Einfamilienhaus",
    mfh: "Mehrfamilienhaus",
    commercial: "Gewerbe / Büro",
    industrial: "Industrie",
    publicBuilding: "Öffentliches Gebäude",
    urgencyTitle: "Wie dringend ist Ihr Projekt?",
    urgencySubtitle: "Zeitrahmen für den Start",
    immediate: "Sofort",
    immediateDesc: "So schnell wie möglich",
    oneWeek: "1 Woche",
    oneWeekDesc: "Innerhalb der nächsten 7 Tage",
    oneMonth: "1 Monat",
    oneMonthDesc: "Innerhalb der nächsten 30 Tage",
    flexible: "Flexibel",
    flexibleDesc: "Kein fester Zeitrahmen",
    budgetTitle: "Welchen Rahmen planen Sie für Ihr Projekt?",
    budgetSubtitle: "Eine Budgetangabe verbessert die Angebotsqualität erheblich.",
    under2k: "Unter 2.000 €",
    budget2k10k: "2.000 bis 10.000 €",
    budget10k50k: "10.000 bis 50.000 €",
    over50k: "Über 50.000 €",
    budgetUnclear: "Noch unklar",
    descriptionTitle: "Beschreiben Sie Ihr Projekt",
    descriptionSubtitle: "Eine detaillierte Beschreibung erhöht Ihre Chancen auf schnelle, passende Angebote.",
    descriptionPlaceholder: "Was soll gemacht werden? Welche Besonderheiten gibt es?",
    desiredStart: "Gewünschter Starttermin (optional)",
    locationTitle: "Wo befindet sich das Projekt?",
    locationSubtitle: "PLZ oder Ort eingeben",
    contactTitle: "Unternehmens- & Kontaktdaten",
    contactSubtitle: "Ihre Daten werden ausschließlich an geprüfte Betriebe weitergegeben.",
    companyInfoTitle: "Unternehmensinformationen",
    companyNameLabel: "Unternehmensname",
    companyNamePlaceholder: "Ihr Firmenname",
    companyPostalCode: "PLZ",
    companyCity: "Ort",
    companyCityPlaceholder: "z.B. Wuppertal",
    companyStreet: "Straße",
    companyStreetPlaceholder: "z.B. Musterstraße 1",
    companyPhoneLabel: "Telefonnummer Zentrale",
    companyEmailLabel: "E-Mail Zentrale",
    companyNote: "Notiz",
    companyNotePlaceholder: "Zusätzliche Hinweise zum Unternehmen...",
    contactPersonTitle: "Ansprechpartner",
    contactNameLabel: "Name",
    contactNamePlaceholder: "Ihr Name",
    contactEmailLabel: "E-Mail",
    contactPhoneLabel: "Telefon",
    contactPhonePlaceholder: "+49 ...",
    contactMobile: "Mobil",
    postalCodePlaceholder: "z.B. 42275",
    phonePlaceholder: "+49 ...",
    emailPlaceholder: "info@firma.de",
    contactEmailPlaceholder: "name@firma.de",
    mobilePlaceholder: "+49 170 ...",
    contactPositionLabel: "Position",
    contactPositionPlaceholder: "z.B. Geschäftsführer",
    addContact: "Weiteren Ansprechpartner hinzufügen (optional)",
    additionalContact: "Weiterer Ansprechpartner",
    toSummary: "Weiter zur Übersicht",
    commitTitle: "Wir prüfen passende Fachbetriebe für Sie",
    commitDesc: "Sie erhalten qualifizierte Rückmeldungen – strukturiert und transparent.",
    summaryTrade: "Gewerk",
    summaryProjectType: "Projektart",
    summaryUrgency: "Dringlichkeit",
    summaryLocation: "Standort",
    summaryBudget: "Budget",
    submitInquiry: "Projektanfrage absenden",
    submitting: "Wird übermittelt...",
    submitSuccess: "Projektanfrage erfolgreich übergeben",
    submitError: "Fehler beim Senden der Anfrage",
  },
  // ─── Thank You Pages ───
  thankyou: {
    inquiryTitle: "Ihre Projektanfrage ist bei uns eingegangen",
    inquiryDesc: "Wir gleichen Ihr Projekt jetzt mit unserem Netzwerk qualifizierter Handwerksbetriebe ab.",
    nextStepsTitle: "So geht es weiter",
    inquiryStep1: "Wir prüfen Ihre Anfrage und finden bis zu 5 passende Handwerksbetriebe.",
    inquiryStep2: "Sie erhalten Kontaktvorschläge per E-Mail – in der Regel innerhalb von 24 Stunden.",
    inquiryStep3: "Sie entscheiden frei, mit welchem Betrieb Sie ins Gespräch gehen.",
    urgentContact: "Bei dringenden Rückfragen erreichen Sie uns unter",
    registrationTitle: "Registrierung eingegangen!",
    registrationDesc: "Vielen Dank für Ihr Interesse an CRAFTFINDUS. Wir haben Ihre Registrierung erhalten.",
    registrationStep1: "Unser Team prüft Ihre Angaben sorgfältig.",
    registrationStep2: "Nach erfolgreicher Prüfung erhalten Sie Ihre Zugangsdaten per E-Mail.",
    registrationStep3: "Sie können sich dann anmelden und sofort qualifizierte Projektanfragen empfangen.",
    reviewTime: "Die Prüfung dauert in der Regel 1–2 Werktage.",
    contactTitle: "Vielen Dank für Ihre Nachricht",
    contactDesc: "Wir haben Ihre Anfrage erhalten und melden uns schnellstmöglich bei Ihnen.",
    contactResponse: "In der Regel antworten wir innerhalb von 24 Stunden an Werktagen. Bei dringenden Anliegen erreichen Sie uns auch telefonisch unter",
    sendAnother: "Weitere Nachricht senden",
  },
  // ─── Contact ───
  contact: {
    seoTitle: "Kontakt – CRAFTFINDUS erreichen",
    seoDesc: "Kontaktieren Sie CRAFTFINDUS: Fragen zu Projektanfragen, Registrierung oder Partnerschaft?",
    title: "Kontakt",
    desc: "Sie haben Fragen zu {{brand}} oder möchten uns direkt erreichen? Wir freuen uns auf Ihre Nachricht.",
    phoneLabel: "Telefon",
    emailLabel: "E-Mail",
    nameLabel: "Name *",
    namePlaceholder: "Ihr Name",
    emailFieldLabel: "E-Mail *",
    emailPlaceholder: "ihre@email.de",
    subjectLabel: "Betreff *",
    subjectPlaceholder: "Worum geht es?",
    messageLabel: "Nachricht *",
    messagePlaceholder: "Ihre Nachricht an uns...",
    sendBtn: "Nachricht senden",
    sending: "Wird gesendet...",
    sent: "Nachricht gesendet!",
    sendFailed: "Versand fehlgeschlagen. Bitte versuchen Sie es später erneut.",
    nameRequired: "Bitte geben Sie Ihren Namen ein",
    emailRequired: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    subjectRequired: "Bitte geben Sie einen Betreff ein",
    messageMin: "Nachricht muss mindestens 10 Zeichen lang sein",
  },
  // ─── About ───
  about: {
    seoTitle: "Über CRAFTFINDUS – Handwerker-Vermittlung fair & intelligent",
    seoDesc: "CRAFTFINDUS verbindet Auftraggeber mit qualifizierten Handwerksbetrieben im DACH-Raum.",
    heroLabel: "Über {{brand}}",
    heroTitle1: "Die Menschen hinter",
    heroTitle2: "CRAFTFINDUS.",
    heroDesc: "{{brand}} entstand aus einer einfachen Beobachtung: Auftraggeber finden schwer den richtigen Handwerksbetrieb. Und gute Handwerker verbringen zu viel Zeit mit Akquise statt mit dem, was sie am besten können.",
    teamLabel: "Unser Team",
    teamTitle: "Die Menschen hinter",
    founderRole: "Gründer",
    founderBio1: "Als Unternehmer aus Solingen kenne ich beide Seiten: Die Frustration von Auftraggebern, die nicht wissen, an welchen Betrieb sie sich wenden sollen. Und die Herausforderung für Handwerksbetriebe, kontinuierlich an qualifizierte Anfragen zu kommen.",
    founderBio2: "{{brand}} ist meine Antwort auf dieses Problem. Eine Plattform, die nicht auf Massenverteilung setzt, sondern auf intelligentes, faires Matching. Wo Qualität zählt und nicht der niedrigste Preis gewinnt.",
    chrisRole: "Geschäftspartner",
    chrisBio: "Chris bringt strategisches Denken und unternehmerische Erfahrung ins Team. Als Geschäftspartner treibt er die Weiterentwicklung von {{brand}} voran und sorgt dafür, dass unsere Vision Realität wird.",
    veronikaRole: "Assistenz der Geschäftsleitung & Backoffice",
    veronikaBio: "Veronika hält im Hintergrund alle Fäden zusammen. Als Assistenz der Geschäftsleitung und Backoffice-Verantwortliche sorgt sie dafür, dass Prozesse reibungslos laufen und das Team sich auf das Wesentliche konzentrieren kann.",
    dukeRole: "Bürohund & Feel-Good-Manager",
    dukeBio: "Kein Meeting ohne Duke. Unser Bull Terrier sorgt für gute Laune, erinnert uns an Pausen und ist fester Bestandteil des Teams. Wer bei uns anruft, hört ihn vielleicht im Hintergrund.",
    valuesLabel: "Unsere Werte",
    valuesTitle: "Wofür wir stehen",
    value1Title: "Qualität vor Quantität",
    value1Desc: "Wir glauben an wenige, dafür passende Verbindungen. Deshalb limitieren wir jede Anfrage auf 3 bis 5 Betriebe. Kein Massenverteiler, kein Preiskampf.",
    value2Title: "Fairness für beide Seiten",
    value2Desc: "Kostenlos für Auftraggeber, transparente Fixpreise für Handwerksbetriebe. Keine versteckten Gebühren, keine Provisionen auf Aufträge.",
    value3Title: "Einfachheit",
    value3Desc: "Handwerk ist komplex genug. Wir übersetzen den Bedarf in die richtige Sprache und machen den Weg zum passenden Betrieb so einfach wie möglich.",
    missionLabel: "Unsere Mission",
    missionTitle: "Handwerker-Vermittlung, wie sie sein sollte",
    missionP1: "Der Handwerksmarkt ist fragmentiert. Tausende Betriebe, unzählige Portale, aber kaum echte Orientierung. Auftraggeber vergleichen Äpfel mit Birnen. Handwerksbetriebe kämpfen um Sichtbarkeit auf überfüllten Plattformen.",
    missionP2: "{{brand}} macht es anders: Wir wählen für jede Anfrage gezielt 3 bis 5 passende Betriebe aus. Kein Bieten, kein Preisdumping. Stattdessen transparente Scores, faire Preise und echte Verbindungen.",
    missionP3: "Unser Ziel: Die erste Anlaufstelle im DACH-Raum für Auftraggeber, die einen Handwerksbetrieb suchen. Und die bevorzugte Quelle für Handwerker, die planbar wachsen wollen.",
    ctaTitle: "Bereit, uns kennenzulernen?",
    ctaDesc: "Ob Sie einen Handwerksbetrieb suchen oder als Handwerker qualifizierte Projektanfragen erhalten möchten: Wir freuen uns auf Sie.",
    ctaInquiry: "Projektanfrage stellen",
    ctaContact: "Kontakt aufnehmen",
  },
  // ─── Pricing ───
  pricing: {
    seoTitle: "Preise – Flexible Abrechnung für Handwerksbetriebe",
    seoDesc: "Transparente Preismodelle: Flex (Pay-per-Contact), Professional oder Premium. Nur qualifizierte Kontakte, faire Abrechnung, kein Risiko.",
    heroLabel: "Preise & Modelle",
    heroTitle1: "Flexible Abrechnung.",
    heroTitle2: "Maximale Transparenz.",
    heroDesc: "Wählen Sie das Modell, das zu Ihrem Betrieb passt – ohne versteckte Kosten.",
    trustBarQualified: "Nur qualifizierte Kontakte",
    trustBarVerified: "Verifizierte Projektdaten",
    trustBarFair: "Fairer Reklamationsprozess",
    posTitle: "Warum CRAFTFINDUS kein klassischer Lead-Marktplatz ist",
    posP1: "Bei vielen Plattformen zahlen Sie für Kontakte – unabhängig von deren Qualität.",
    posP2: "CRAFTFINDUS arbeitet anders.",
    posP3: "Unsere Projekte werden vorqualifiziert, strukturiert und geprüft, bevor sie freigeschaltet werden.",
    posP4: "Sie investieren in echte, nachvollziehbare Projektanfragen – nicht in unklare Kontaktversuche.",
    modelsLabel: "Preismodelle",
    modelsTitle: "Drei Modelle – Ihre Wahl",
    flexSub: "Pay-per-Contact",
    flexDesc: "Ideal für flexible Auslastung. Sie zahlen nur bei Kontaktfreischaltung.",
    flexF1: "Verifizierte Kontaktdaten",
    flexF2: "Budgetangabe vorhanden",
    flexF3: "Projektbeschreibung geprüft",
    flexF4: "Keine Grundgebühr",
    flexCta: "Flex-Modell starten",
    proSub: "Empfohlen",
    proDesc: "Planbare Leads + reduzierte Kontaktpreise.",
    proF1: "Monatliches Kontaktkontingent",
    proF2: "Reduzierte Einzelpreise",
    proF3: "Priorisierte Sichtbarkeit",
    proF4: "Performance-Dashboard",
    proCta: "Professional sichern",
    premSub: "Maximale Sichtbarkeit",
    premDesc: "Maximale Sichtbarkeit & Priorisierung.",
    premF1: "Bevorzugtes Matching",
    premF2: "Premium-Badge",
    premF3: "Erweiterte Analytics",
    premF4: "Exklusive Projektkategorien",
    premCta: "Premium-Partnerschaft starten",
    roiLabel: "EINE EINFACHE RECHNUNG",
    roiTitle: "Ihr Return on Investment",
    roiText: "Durchschnittlicher Auftragswert: 4.000+ €. 1–2 gewonnene Projekte pro Monat decken die Plattformkosten mehrfach.",
    roiAvgProject: "Ø Auftragswert eines Projekts",
    roiProjectsNeeded: "Projekte pro Monat decken Ihre Kosten",
    roiResult: "Ihre Investition amortisiert sich bereits mit dem ersten gewonnenen Auftrag.",
    qualityLabel: "LEAD-QUALITÄTS-ENGINE",
    qualityTitle: "Nur qualifizierte Kontakte – garantiert",
    qualityDesc: "Jede Projektanfrage wird automatisch bewertet. Nur Leads mit einem Qualitäts-Score von mindestens 60 Punkten werden Ihnen in Rechnung gestellt.",
    qPhone: "Telefonnummer verifiziert",
    qBudget: "Budget angegeben",
    qImages: "Bilder hochgeladen",
    qDesc: "Beschreibung > 200 Zeichen",
    qUrgency: "Hohe Dringlichkeit",
    qContact: "Kontaktdaten vollständig",
    qualityMin: "Minimum 60 Punkte = abrechenbarer Kontakt. Das ist unser Qualitätsversprechen.",
    plansLabel: "ABO-PLÄNE",
    plansTitle: "Abo-Pläne im Überblick",
    leadsIncluded: "angenommene Leads inklusive",
    choosePlan: "Plan wählen",
    mostPopular: "Beliebteste Wahl",
    addonsLabel: "Add-ons",
    addonsTitle: "Zusätzliche Leads buchen",
    radiusLabel: "Radius-Erweiterungen",
    radiusTitle: "Einsatzgebiet erweitern",
    radiusDesc: "Erweitern Sie Ihren Einsatzradius und erhalten Sie Projektanfragen aus einem größeren Gebiet.",
    trustNoContract: "Keine Vertragsbindung",
    trustInstant: "Sofort startklar",
    trustVerified: "Nur geprüfte Anfragen",
    landingLabel: "Preise für Handwerksbetriebe",
    landingTitle: "Transparente Preismodelle",
    landingDesc: "Wählen Sie das Modell, das zu Ihrem Betrieb passt – keine versteckten Kosten, keine Vertragsbindung.",
    landingCta: "Alle Modelle ansehen",
    faqLabel: "Einwände vorwegnehmen",
    faqTitle: "Häufige Fragen zu unseren Preisen",
    ctaTitle: "Bereit für qualifizierte Projekte?",
    ctaDesc: "Registrieren Sie sich kostenlos, wählen Sie Ihr Modell und erhalten Sie vorgeprüfte Projektanfragen – ohne Risiko.",
    ctaBtn: "Mehr qualifizierte Projekte sichern",
    faq1q: "Was passiert bei nicht erreichbaren Kontakten?",
    faq1a: "Sie können innerhalb von 72 Stunden eine Reklamation einreichen. Bei nicht erreichbaren Kontakten oder falschem Gewerk erhalten Sie Ihren Kontaktpreis zurück – garantiert.",
    faq2q: "Wie funktioniert die Reklamation?",
    faq2a: "Direkt in Ihrem Dashboard: Reklamation einreichen, Grund angeben, fertig. Unser Operator-Team prüft und entscheidet transparent. Berechtigte Reklamationen werden sofort erstattet.",
    faq3q: "Gibt es Vertragsbindung?",
    faq3a: "Nein. Sie können Ihr Modell jederzeit wechseln oder kündigen. Keine Mindestlaufzeit, keine Kündigungsfrist.",
    faq4q: "Sind die Projekte echt?",
    faq4a: "Ja. Jede Anfrage durchläuft unsere Qualitäts-Engine: Telefonnummer verifiziert, Budget angegeben, Projektbeschreibung geprüft. Nur Anfragen mit Score > 60 werden freigeschaltet.",
    faq5q: "Was unterscheidet CRAFTFINDUS von anderen Plattformen?",
    faq5a: "Qualität statt Masse: Max. 3-5 Betriebe pro Projekt, keine Massenverteilung. Transparente Preise, fairer Reklamationsprozess und verifizierte Betriebe.",
  },
  // ─── Billing ───
  billing: {
    title: "Abrechnung & Plan",
    subtitle: "Verwalten Sie Ihren Plan, Kontingente und Zahlungsmethode",
    tabPlan: "Plan & Abrechnung",
    tabQuotas: "Kontingente",
    tabPayment: "Zahlungsmethode",
    statusActive: "Aktiv",
    statusTrial: "Testphase",
    statusPastDue: "Zahlung ausstehend",
    statusBlocked: "Gesperrt",
    statusCanceled: "Gekündigt",
    statusPending: "Ausstehend",
    pastDueBanner: "Zahlung fehlgeschlagen. Bitte aktualisieren Sie Ihre Zahlungsmethode.",
    blockedBanner: "Abo gesperrt. Bitte schließen Sie die Zahlung ab, um fortzufahren.",
    updatePayment: "Zahlungsmethode aktualisieren",
    cancelledNotice: "Ihr Abo endet am {{date}}.",
    cancelSub: "Abo kündigen",
    cancelConfirm: "Möchten Sie Ihr Abo wirklich zum Periodenende kündigen?",
    cancelSuccess: "Abo wird zum Periodenende gekündigt",
    noPlan: "Kein aktiver Plan",
    noPlanDesc: "Wählen Sie einen Plan, um qualifizierte Projektanfragen zu erhalten.",
    changePlan: "Plan wechseln",
    selectPlan: "Plan wählen",
    currentPlan: "Aktuell",
    activePlan: "Aktiver Plan",
    leadsIncl: "Leads inkl.",
    addonsTitle: "Add-ons",
    buy: "Kaufen",
    acceptedLeads: "Angenommene Leads",
    deliveries: "Zustellungen",
    quotaReached: "Kontingent erreicht – Add-on kaufen oder Plan upgraden",
    billingPeriod: "Abrechnungszeitraum",
    periodResets: "Kontingente werden automatisch zum Periodenbeginn zurückgesetzt.",
  },
  // ─── Invoices ───
  invoices: {
    title: "Rechnungsübersicht",
    subtitle: "Alle Zahlungen und Rechnungen auf einen Blick",
    empty: "Noch keine Rechnungen",
    emptyDesc: "Sobald Zahlungen anfallen, erscheinen sie hier.",
    colDate: "Datum",
    colDescription: "Beschreibung",
    colAmount: "Betrag",
    colStatus: "Status",
    colMethod: "Methode",
    download: "Beleg herunterladen",
    statusPaid: "Bezahlt",
    statusOpen: "Offen",
    statusPending: "Ausstehend",
    statusCanceled: "Storniert",
    statusExpired: "Abgelaufen",
    statusFailed: "Fehlgeschlagen",
  },
  // ─── Registration ───
  registration: {
    seoTitle: "Handwerksbetrieb registrieren – Qualifizierte Projektanfragen erhalten",
    seoDesc: "Als Handwerksbetrieb bei CRAFTFINDUS registrieren: In 15 Minuten startklar.",
    title: "Als Handwerksbetrieb registrieren",
    subtitle: "Füllen Sie das Formular aus. Nach Prüfung erhalten Sie Ihre Zugangsdaten per E-Mail.",
    requiredFields: "Pflichtfelder: Betriebsname, Kontaktperson, E-Mail",
    fillRequired: "Bitte füllen Sie Betriebsname, Kontaktperson und E-Mail aus.",
    submitting: "Wird gesendet...",
    submitBtn: "Registrierung absenden",
    submitError: "Fehler beim Absenden",
  },
  // ─── FuerHandwerker ───
  handwerker: {
    seoTitle: "Qualifizierte Projektanfragen – Keine Billig-Leads",
    seoDesc: "Keine Kaltakquise, kein Preiskampf: CRAFTFINDUS liefert vorqualifizierte Projektanfragen mit verifizierten Kontakten, Budget-Bestätigung und fairem Reklamationsprozess.",
    heroLabel: "Für Handwerksbetriebe & Meisterbetriebe",
    heroTitle1: "Keine Billig-Anfragen.",
    heroTitle2: "Nur qualifizierte Projekte.",
    heroDesc: "Verifizierte Kontaktdaten. Budget bestätigt. Strukturierte Projektbeschreibung. Fairer Reklamationsprozess. {{brand}} liefert nur Anfragen, die sich lohnen.",
    registerFree: "Mehr qualifizierte Projekte sichern",
    badgeNoContract: "Keine Vertragsbindung",
    badgeReady: "In 15 Min. startklar",
    badgeVerified: "Nur geprüfte Anfragen",
    badgePayOnAccept: "Zahlung nur bei angenommenem Projekt",
    benefitsLabel: "Ihre Vorteile",
    benefitsTitle: "Warum Handwerksbetriebe {{brand}} wählen",
    benefit1Title: "Passgenau gematcht",
    benefit1Desc: "Unser Algorithmus gleicht jede Anfrage mit Ihrem Profil ab: Gewerk, Region, Kapazität. Sie erhalten nur Projekte, die wirklich zu Ihnen passen.",
    benefit2Title: "Max. 3 bis 5 Betriebe pro Projekt",
    benefit2Desc: "Kein Massenverteiler. Jede Anfrage geht an wenige, ausgewählte Handwerksbetriebe. Weniger Wettbewerb, höhere Abschlussquoten.",
    benefit3Title: "Transparente Fixpreise",
    benefit3Desc: "Sie zahlen nur pro angenommener Anfrage – einen festen, transparenten Preis. Keine monatlichen Gebühren, keine Provisionen.",
    benefit4Title: "Vorqualifizierte Anfragen",
    benefit4Desc: "Jede Projektanfrage wird geprüft, bevor sie an Sie weitergeleitet wird. Kein Spam, keine Fantasie-Anfragen – nur echte Projekte.",
    benefit5Title: "Planbares Wachstum",
    benefit5Desc: "Bestimmen Sie flexibel, wie viele Anfragen Sie pro Monat annehmen – und steuern Sie Ihre Auslastung.",
    benefit6Title: "Schneller Zugang",
    benefit6Desc: "Registrieren, Profil anlegen, erste Anfragen erhalten. In unter 15 Minuten sind Sie startklar.",
    pricingLabel: "Preisbeispiele",
    pricingTitle: "Transparente Fixpreise pro Projektanfrage",
    pricingDesc: "Sie zahlen nur für Anfragen, die Sie aktiv annehmen. Der Preis richtet sich nach Projektkategorie und -größe.",
    smallProjects: "Kleinprojekte",
    smallExamples: "z. B. Steckdosen setzen, Wasserhahn reparieren, Wand streichen, Türschloss tauschen",
    mediumProjects: "Mittlere & große Projekte",
    mediumExamples: "z. B. Bad-Renovierung, Heizungsaustausch, PV-Anlage, Dachsanierung, Komplettsanierung",
    priceFrom: "ab {{price}} €",
    perAcceptedInquiry: "pro angenommener Projektanfrage",
    goodToKnow: "Gut zu wissen",
    goodToKnow1: "Keine monatlichen Gebühren. Sie zahlen nur bei Annahme",
    goodToKnow2: "Projektgröße bestimmt den Preis – vorab transparent sichtbar",
    goodToKnow3: "Reklamation bei Fehlqualifizierung – Erstattung garantiert",
    goodToKnow4: "Abrechnung über Ihre hinterlegte Zahlungsmethode",
    howLabel: "So funktioniert's",
    howTitle: "In 3 Schritten zu neuen Projekten",
    step1Title: "Profil anlegen",
    step1Desc: "Gewerk, Region, Kapazität und Spezialisierung angeben.",
    step2Title: "Projektanfragen erhalten",
    step2Desc: "Passende Projekte werden Ihnen automatisch zugestellt.",
    step3Title: "Annehmen & kontaktieren",
    step3Desc: "Sie entscheiden, welche Projekte Sie annehmen und sprechen direkt mit dem Kunden.",
    startNow: "Jetzt starten",
    faqLabel: "Häufige Fragen",
    faqTitle: "Fragen von Handwerksbetrieben",
    faq1q: "Was kostet CRAFTFINDUS für Handwerksbetriebe?",
    faq1a: "Sie zahlen nur pro angenommener Anfrage einen transparenten Fixpreis. Keine monatlichen Gebühren, keine Provisionen. Sie entscheiden selbst, welche Anfragen Sie annehmen.",
    faq2q: "Wie funktioniert das Matching?",
    faq2a: "Unser Algorithmus analysiert jede Anfrage und gleicht sie mit Ihrem Profil ab: Gewerk, Spezialisierung, Region und aktuelle Kapazität. Nur bei hoher Passung erhalten Sie die Anfrage.",
    faq3q: "Wie viele Anfragen bekomme ich?",
    faq3a: "Das hängt von Ihrem Profil, Ihrer Region und Ihrem Einsatzradius ab. Sie können ein Wochenlimit setzen, um Ihre Kapazität zu steuern. Qualität geht bei uns immer vor Quantität.",
    faq4q: "Gibt es eine Vertragsbindung?",
    faq4a: "Nein. Sie können CRAFTFINDUS jederzeit ohne Kündigungsfrist verlassen. Es gibt keine Mindestlaufzeit und keine versteckten Kosten.",
    faq5q: "Was unterscheidet CRAFTFINDUS von anderen Portalen?",
    faq5a: "Kein Bieten, kein Preisdumping. Bei CRAFTFINDUS werden Handwerksbetriebe ausgewählt, nicht gesucht. Die Limitierung auf 3 bis 5 Betriebe pro Anfrage sichert faire Chancen.",
    ctaTitle: "Bereit für Anfragen, die sich lohnen?",
    ctaDesc: "Registrieren Sie sich kostenlos und erhalten Sie vorqualifizierte Projektanfragen – ohne Vertragsbindung, ohne Preiskampf.",
    ctaBtn: "Mehr qualifizierte Projekte sichern",
  },
  // ─── Not Found ───
  notFound: {
    title: "Seite nicht gefunden",
    description: "Die angeforderte Seite existiert nicht.",
  },
  // ─── Limit Reached ───
  limitReached: {
    title: "Pause",
    subtitle: "Ihr Wochenlimit ist erreicht.",
    nextReset: "Nächste Freischaltung",
    description: "Das Limit schützt die Qualität der Plattform und stellt sicher, dass jede Anfrage die volle Aufmerksamkeit erhält.",
    adjustLimit: "Limit anpassen",
  },
  // ─── Skip Link ───
  skipLink: "Zum Hauptinhalt springen",
  // ─── Portal Sidebar ───
  portal: {
    switchPortal: "Portal wechseln",
    profile: "Profil",
    changePassword: "Kennwort ändern",
    signOut: "Abmelden",
    newPassword: "Neues Kennwort",
    passwordPlaceholder: "Mindestens 6 Zeichen",
    saving: "Wird gespeichert...",
    saveBtn: "Speichern",
    cancelBtn: "Abbrechen",
  },
  // ─── Opportunity Detail ───
  opportunityDetail: {
    company: "Unternehmen",
    confidentialUntilAccept: "Vertraulich bis Annahme",
    notSpecified: "Nicht angegeben",
    urgency: "Dringlichkeit",
    decision: "Entscheidung",
    matchScore: "Match-Score",
    location: "Standort",
    remote: "Remote",
    remotePossible: "Möglich",
    onsite: "Vor Ort",
    compliance: "Compliance",
    complianceRelevant: "Relevant",
    onsiteLabel: "Vor-Ort",
    onsiteRequired: "Erforderlich",
    context: "Kontext",
    whySelected: "Warum Sie ausgewählt wurden",
    inquiryAccess: "Anfrage-Zugang",
    accepting: "Wird angenommen...",
    acceptInquiry: "Anfrage annehmen",
    decline: "Ablehnen",
    responseWindow: "Reaktionsfenster: 2h empfohlen",
    claimLabel: "Reklamation",
    claimBtn: "Reklamieren",
    completed: "Abgeschlossen",
    won: "Gewonnen",
    lost: "Verloren",
    noFit: "Kein Fit",
    claimApproved: "Angenommen",
    claimRejected: "Abgewiesen",
    claimUnderReview: "In Prüfung",
    claimSubmitted: "Eingereicht",
    submittedAt: "Eingereicht am",
    decidedAt: "Entschieden am",
    reason: "Grund",
    rejectionReason: "Begründung der Ablehnung",
    note: "Hinweis",
    expiresIn: "Verfällt in {{hours}}h",
    expired: "Abgelaufen",
  },
  // ─── Registration Form (RegStammdaten, RegKontakte, RegService) ───
  regForm: {
    companyData: "Betriebsdaten",
    companyName: "Betriebsname *",
    companyNamePlaceholder: "Ihr Handwerksbetrieb",
    companyType: "Unternehmensart",
    companyTypePlaceholder: "– Bitte wählen –",
    legalName: "Rechtlicher Name",
    legalNamePlaceholder: "z.B. lt. Handelsregister",
    contactPerson: "Kontaktperson *",
    contactPersonPlaceholder: "Ihr Name",
    role: "Rolle / Position",
    rolePlaceholder: "z.B. Meister, Geschäftsführer",
    email: "E-Mail *",
    emailPlaceholder: "ihre@email.de",
    phone: "Telefon",
    phonePlaceholder: "+49 ...",
    website: "Website",
    websitePlaceholder: "https://...",
    invoiceEmail: "Rechnungs-E-Mail",
    invoiceEmailPlaceholder: "buchhaltung@betrieb.de",
    address: "Adresse",
    street: "Straße & Hausnummer",
    postalCode: "PLZ",
    city: "Stadt",
    country: "Land",
    countryDE: "Deutschland",
    countryAT: "Österreich",
    countryCH: "Schweiz",
    vatId: "USt-IdNr.",
    vatIdPlaceholder: "DE123456789",
    contacts: "Ansprechpartner",
    contactsDesc: "Optional: Weitere Kontaktpersonen in Ihrem Unternehmen",
    addContact: "Kontakt hinzufügen",
    noContacts: "Noch keine weiteren Ansprechpartner",
    createContact: "Kontakt anlegen",
    contactN: "Kontakt {{n}}",
    primaryContact: "Hauptkontakt",
    setPrimary: "Als Hauptkontakt",
    nameRequired: "Name *",
    emailRequired: "E-Mail *",
    rolePlaceholderShort: "z.B. Vertrieb",
  },
  // ─── Stack Accordion Picker ───
  stackPicker: {
    noResults: "Keine Technologie gefunden",
    addCustom: "Eigene Technologie hinzufügen",
    customPlaceholder: "z.B. SAP, DATEV, Lexware...",
  },
  // ─── Operator TabService ───
  opService: {
    regionsTitle: "Regionen & Einsatzgebiet",
    mainRegion: "Hauptregion",
    pleaseSelect: "Bitte wählen",
    serviceRegions: "Service-Regionen (Mehrfachauswahl)",
    serviceLocations: "Einsatzorte mit Umkreis",
    serviceLocationsDesc: "Konkrete Standorte mit Einsatzradius definieren",
    addLocation: "Standort",
    noLocations: "Optional: Einsatzorte mit Umkreis für präziseres Matching",
    locationN: "Standort {{n}}",
    locationCity: "Stadt / Ort *",
    locationCityPlaceholder: "z.B. München",
    locationPostal: "PLZ",
    locationPostalPlaceholder: "z.B. 80331",
    locationRadius: "Umkreis (km)",
    remoteSupport: "Remote-Support möglich",
    serviceCategories: "Service-Kategorien",
    expertiseTitle: "Fachgebiete & Spezialisierungen",
    tagsLoading: "Tags werden geladen...",
    slaTitle: "SLA & Kontingente",
    slaTier: "SLA-Tier",
    sla2h: "2 Stunden",
    sla4h: "4 Stunden",
    slaNBD: "Next Business Day",
    slaResponseTime: "SLA Reaktionszeit (h)",
    weeklyLimit: "Wochenlimit",
    monthlyLimit: "Monatslimit",
    qualityTitle: "Qualitätskennzahlen (Initial)",
    qualityDesc: "Startwerte für neue Provider. Werden automatisch angepasst.",
    qualityScore: "Quality-Score",
    qualityScoreRange: "0.00 – 1.00",
    acceptanceRate: "Annahme-Quote",
    avgResponseTime: "Ø Reaktionszeit (h)",
  },
  // (avatarPicker keys moved to bottom of file)
  // ─── Operator Sales Benchmarks ───
  salesBenchmarks: {
    costPerLead: "Kosten pro qualifiziertem Lead",
    conversionFirstMeeting: "Conversion Lead → Erstgespräch",
    conversionCustomer: "Conversion Lead → Kunde",
    cac: "Customer Acquisition Cost",
  },
  // ─── Thank You (RegistrierenDanke) ───
  thankyouExtra: {
    orVia: "oder per",
    emailLabel: "E-Mail",
  },
  // ─── Provider Detail extra ───
  pdExtra: {
    slaResponseTime: "SLA Reaktionszeit",
  },
  // ─── Completion Dialog ───
  completionDialog: {
    confirmTitle: "Anfrage abschließen",
    confirmDesc: "Ist die Anfrage abgeschlossen und der Kontakt zum Kunden beendet?",
    confirmYes: "Ja, abschließen",
    confirmNo: "Nein, zurück",
    outcomeTitle: "Ergebnis",
    outcomeDesc: "Ist ein Auftrag zustande gekommen?",
    won: "Ja – Auftrag gewonnen",
    lost: "Nein – Auftrag verloren",
    noFit: "Kein Fit / Nicht weiterverfolgt",
  },
  // ─── Suche (Search Landing) ───
  suche: {
    seoTitle: "Handwerksbetrieb finden – kostenlos & ohne Registrierung",
    seoDesc: "Passenden Handwerksbetrieb finden: kostenlos, unverbindlich & DSGVO-konform. Beschreiben Sie Ihr Projekt – bis zu 5 geprüfte Handwerker aus Ihrer Region melden sich in 24h.",
    trustDach: "🇩🇪 🇦🇹 🇨🇭 DACH-weit",
    trustFree: "100 % kostenlos",
    trustGdpr: "DSGVO-konform",
    trustConsent: "Keine Weitergabe ohne Zustimmung",
    heroTitle: "Den passenden Handwerksbetrieb finden.",
    heroAccent: "Kostenlos, unverbindlich & ohne Registrierung",
    heroDesc: "Wir finden die passenden Handwerksbetriebe aus Ihrer Region durch intelligentes Matching. Sie erhalten bis zu 5 Angebote qualifizierter Betriebe. Sie wählen aus, wer am besten zu Ihrem Projekt passt.",
    heroCta: "Jetzt passenden Handwerksbetrieb finden",
    heroSubline: "Kostenlos · Unverbindlich · Rückmeldung innerhalb von 24h",
    howBtn: "Wie funktioniert {{brand}}?",
    howTitle: "Wie funktioniert {{brand}}?",
    howIntro: "{{brand}} vermittelt Auftraggeber an qualifizierte Handwerksbetriebe im DACH-Raum. So läuft der Prozess ab:",
    howStep1: "Sie beschreiben Ihr Projekt",
    howStep1Desc: "in wenigen Schritten, ohne Fachbegriffe.",
    howStep2: "Intelligentes Matching",
    howStep2Desc: "unser Algorithmus findet passende Betriebe aus Ihrer Region.",
    howStep3: "Menschliche Validierung",
    howStep3Desc: "jede Zuordnung wird geprüft, bevor sie rausgeht.",
    howStep4: "Bis zu 5 Betriebe melden sich",
    howStep4Desc: "persönlich und direkt bei Ihnen.",
    howFreeTitle: "Für Sie komplett kostenlos",
    howFreeDesc: "Die Kosten trägt der Handwerksbetrieb. Für Sie als Auftraggeber ist der Service zu 100 % kostenlos und unverbindlich.",
    problemsTitle: "Sie kennen das",
    problemsAccent: "Problem",
    problemsSuffix: ". Wir finden die Lösung",
    problemsDesc: "Kein Fachwissen nötig. Beschreiben Sie einfach, was gemacht werden soll.",
    problem1: "Heizung defekt oder Sanitärinstallation nötig",
    problem2: "Elektroinstallation oder Photovoltaik-Anlage planen",
    problem3: "Dach reparieren oder neu eindecken lassen",
    problem4: "Innenausbau, Trockenbau oder Malerarbeiten",
    problem5: "Fenster, Türen oder Fassade erneuern",
    problem6: "Garten- oder Landschaftsbau beauftragen",
    problemsCta: "Jetzt Projekt beschreiben",
    problemsCtaSub: "Kein Fachwissen erforderlich · Geführter Prozess",
    stepsTitle: "In 3 Schritten zum",
    stepsAccent: "richtigen Handwerker",
    stepsDesc: "So einfach funktioniert {{brand}} für Sie",
    step1Title: "Projekt beschreiben",
    step1Desc: "Beschreiben Sie in wenigen Schritten, welche Handwerksleistung Sie benötigen. Kein Fachwissen nötig.",
    step2Title: "Wir matchen für Sie",
    step2Desc: "Unser Algorithmus findet die passenden Handwerksbetriebe aus Ihrer Region. Handverlesen, nicht zufällig.",
    step3Title: "Angebote erhalten",
    step3Desc: "Innerhalb von 24 Stunden melden sich bis zu 5 qualifizierte Betriebe mit konkreten Angeboten bei Ihnen.",
    stepsBanner: "Komplett kostenlos · Keine versteckten Kosten · Keine Provision",
    exampleTitle: "So sieht eine",
    exampleAccent: "Projektanfrage",
    exampleSuffix: " aus",
    exampleLabel: "Beispiel-Projektanfrage",
    exampleName: "Badezimmer-Sanierung komplett",
    exampleRegion: "Solingen",
    exampleObject: "Einfamilienhaus",
    exampleUrgency: "Innerhalb von 1 Monat",
    exampleMatched: "4 passende Betriebe gefunden",
    regionLabel: "Region",
    objectLabel: "Objekt",
    timeframeLabel: "Zeitrahmen",
    resultLabel: "Ergebnis",
    exampleResult: "Innerhalb von <strong>24 Stunden</strong> erhielt dieser Auftraggeber 4 passende Angebote.",
    exampleCta: "Eigene Projektanfrage stellen",
    whyTitle: "Warum Auftraggeber {{brand}} nutzen",
    why1: "Komplett kostenlos, keine versteckten Gebühren oder Provisionen",
    why2: "DSGVO-konforme Datenverarbeitung in Deutschland",
    why3: "Ihre Daten werden erst nach Zustimmung an passende Handwerksbetriebe (max. 5) weitergegeben",
    why4: "Handverlesene Betriebe, max. 5 pro Anfrage",
    why5: "Rückmeldung innerhalb von 24 Stunden",
    why6: "Persönlicher Support bei Fragen",
    whyTrust: "Vertraut von Auftraggebern aus dem DACH-Raum",
    ctaTitle: "Bereit, den passenden",
    ctaAccent: "Handwerksbetrieb",
    ctaSuffix: " zu finden?",
    ctaDesc: "Beschreiben Sie Ihr Projekt. Wir kümmern uns um den Rest.\nKostenlos, unverbindlich und ohne Verpflichtung.",
    ctaBtn: "Jetzt passenden Handwerksbetrieb finden",
    ctaSubline: "Kostenlos · Unverbindlich · Keine Weitergabe ohne Zustimmung · In 24h Rückmeldung",
    ctaPhone: "Sie haben Fragen? Rufen Sie uns an unter",
    ctaForCraft: "Für Handwerksbetriebe →",
    ctaForLeads: "Projektanfragen für Betriebe →",
    ctaContact: "Kontakt →",
  },
  // ─── Leads (Provider Landing) ───
  leads: {
    seoTitle: "Projektanfragen erhalten – Qualifizierte Aufträge für Handwerksbetriebe",
    seoDesc: "Vorqualifizierte Projektanfragen aus DACH: Aufträge passend zu Gewerk, Region & Kapazität. Keine Kaltakquise, keine Abos. Zahlung nur bei Annahme. Max. 5 Betriebe pro Anfrage.",
    trustDach: "🇩🇪 🇦🇹 🇨🇭 DACH-weit",
    trustGdpr: "DSGVO-konform",
    trustMax5: "Max. 5 Betriebe pro Anfrage",
    trustPayOnAccept: "Zahlung erst nach Annahme",
    trustNoSubs: "Keine Abos",
    trustCancelAnytime: "Jederzeit kündbar",
    heroTitle: "Qualifizierte Projektanfragen aus Ihrer Region.",
    heroAccent: "Sie zahlen nur, wenn Sie sie annehmen",
    heroDesc: "Keine Kaltakquise. Keine Abos.\nNur echte Projektanfragen von Kunden aus DACH.",
    heroCta: "Jetzt kostenlose Registrierung starten",
    heroSubline: "Keine Kosten · Keine Verpflichtung · Zahlung erst nach Annahme",
    benefitsTitle: "Ihre Vorteile als",
    benefitsAccent: "Handwerksbetrieb",
    benefit1Title: "Echte Projektanfragen",
    benefit1Desc: "Vorqualifizierte Anfragen mit echtem Bedarf. Keine Kaltakquise, kein Zeitverlust.",
    benefit2Title: "Volle Kontrolle",
    benefit2Desc: "Sie entscheiden, welche Anfragen Sie annehmen. Ablehnen ist jederzeit kostenlos möglich.",
    benefit3Title: "Zahlung nach Annahme",
    benefit3Desc: "Erst wenn Sie eine Anfrage aktiv annehmen, entstehen Kosten. Keine Abos, keine Vorauszahlung.",
    benefitsCta: "Jetzt kostenlose Registrierung starten",
    howTitle1: "Einfach. Transparent.",
    howAccent: "Fair.",
    howDesc: "So funktioniert {{brand}}: in drei Schritten",
    howStep1: "Projektanfrage erfassen",
    howStep1Desc: "Ein Kunde beschreibt sein Projekt: Gewerk, Region und Dringlichkeit.",
    howStep2: "Intelligentes Matching",
    howStep2Desc: "Unser Algorithmus wählt nur Handwerksbetriebe aus, deren Profil wirklich zum Projekt passt.",
    howStep3: "Sie entscheiden",
    howStep3Desc: "Sie sehen die Anfrage vorab und zahlen nur, wenn Sie sie aktiv annehmen.",
    howBanner: "Kein Abo · Keine Mindestabnahme · Keine Verpflichtung",
    faqQ1: "Was bedeutet \u201Equalifizierte Projektanfrage\u201C?",
    faqA1: "Eine Anfrage mit echtem Projektbedarf, klarem Gewerk, Region und Kontaktmöglichkeit.",
    faqQ2: "Wann entstehen Kosten?",
    faqA2: "Erst wenn Sie eine Anfrage aktiv annehmen.",
    faqQ3: "Kann ich Anfragen ablehnen?",
    faqA3: "Ja, jederzeit und ohne Kosten.",
    trustTitle: "Warum Handwerksbetriebe",
    trustAccent: "{{brand}} wählen",
    trust1: "Keine Vorauszahlung: Sie zahlen erst nach Annahme",
    trust2: "Transparente Projekt-Infos vor der Entscheidung",
    trust3: "Region & Gewerke individuell steuerbar",
    trust4: "Fair verteilt, kein Lead-Overload, kein Preiskampf",
    trust5: "Ersatz bei Fehlqualifizierung, garantiert",
    trustCta: "Jetzt kostenlose Registrierung starten",
    exampleTitle: "So sieht eine",
    exampleAccent: "Projektanfrage",
    exampleSuffix: " aus",
    exampleLabel: "Neue Projektanfrage",
    exampleName: "Badsanierung Einfamilienhaus",
    exampleMax5: "Diese Anfrage wurde an max. <strong>5 Betriebe</strong> gesendet.",
    exampleCta: "Solche Anfragen erhalten",
    regionLabel: "Region",
    tradeLabel: "Gewerk",
    budgetLabel: "Budget",
    urgencyLabel: "Dringlichkeit",
    objectLabel: "Objekt",
    securityTitle: "Vertrauen ist die",
    securityAccent: "Basis",
    security1: "DSGVO-konforme Datenverarbeitung in Deutschland",
    security2: "Keine Weitergabe von Kontaktdaten ohne Ihre Zustimmung",
    security3: "Persönlicher Support & klare, faire Regeln",
    security4: "Transparente Preise pro Anfrage, keine versteckten Kosten",
    securityTrust: "Vertraut von Pilotkunden aus dem DACH-Raum",
    ctaTitle: "Bereit für echte",
    ctaAccent: "Projektanfragen?",
    ctaDesc: "Registrieren Sie sich jetzt und entscheiden Sie selbst,\nwelche Anfragen Sie annehmen möchten.",
    ctaBtn: "Jetzt kostenlose Registrierung starten",
    ctaSubline: "Keine Kosten · Keine Verpflichtung · Zahlung erst nach Annahme · Jederzeit kündbar",
    ctaForCraft: "Vorteile für Handwerksbetriebe →",
    ctaForSearch: "Für Projektsuchende →",
    ctaAbout: "Über CRAFTFINDUS →",
  },
  // ─── Feedback ───
  feedback: {
    seoThankYou: "Feedback – Vielen Dank",
    thankYouTitle: "Vielen Dank!",
    thankYouDesc: "Ihr Feedback wurde erfolgreich übermittelt und hilft uns, die Qualität unserer Dienstleister zu verbessern.",
    errorTitle: "Fehler",
    invalidLink: "Ungültiger oder abgelaufener Link.",
    formTitle: "Ihr Feedback",
    formDesc: "Bewerten Sie Ihre Erfahrung mit <strong>{{provider}}</strong>",
    submitBtn: "Feedback absenden",
    submitting: "Wird gesendet…",
    anonymous: "Ihr Feedback ist anonym gegenüber dem Dienstleister.",
    answerPlaceholder: "Ihre Antwort…",
  },
  // ─── Withdraw Request ───
  withdraw: {
    seoTitle: "Anfrage zurückziehen",
    seoDesc: "Ziehen Sie Ihre Projektanfrage bei CRAFTFINDUS zurück.",
    loading: "Link wird überprüft…",
    errorTitle: "Link ungültig",
    noToken: "Kein Token angegeben.",
    alreadyTitle: "Bereits zurückgezogen",
    alreadyDesc: "Diese Anfrage wurde bereits storniert.",
    title: "Anfrage zurückziehen",
    confirmQuestion: "Möchten Sie die folgende Anfrage wirklich zurückziehen?",
    requestNumber: "Anfrage-Nr.",
    category: "Kategorie",
    company: "Unternehmen",
    createdAt: "Erstellt am",
    reasonLabel: "Begründung",
    reasonPlaceholder: "Warum möchten Sie die Anfrage zurückziehen?",
    reasonMin: "Mindestens 5 Zeichen erforderlich",
    warning: "Durch das Zurückziehen werden alle zugeordneten Handwerksbetriebe informiert und die Anfrage wird storniert. Dieser Vorgang kann nicht rückgängig gemacht werden.",
    submitBtn: "Anfrage verbindlich zurückziehen",
    submitting: "Anfrage wird zurückgezogen…",
    successTitle: "Anfrage zurückgezogen",
    successDesc: "Ihre Anfrage wurde erfolgreich storniert.",
    notifiedOne: "{{count}} zugeordneter Handwerksbetrieb wurde benachrichtigt.",
    notifiedMany: "{{count}} zugeordnete Handwerksbetriebe wurden benachrichtigt.",
  },
  // ─── Profile Edit ───
  profileEdit: {
    title: "Profil bearbeiten",
    subtitle: "Stammdaten, Adresse, Kontakt, Gewerke und Limits",
    companySection: "Unternehmen",
    companyName: "Firmenname *",
    companyType: "Unternehmensart",
    companyTypePlaceholder: "– Bitte wählen –",
    legalName: "Rechtlicher Name",
    legalNamePlaceholder: "z.B. Muster GmbH",
    vatId: "USt-IdNr.",
    vatIdPlaceholder: "DE123456789",
    website: "Website",
    addressSection: "Adresse",
    street: "Straße & Hausnummer",
    postalCode: "PLZ",
    city: "Stadt",
    country: "Land",
    contactSection: "Hauptkontakt",
    contactName: "Ansprechpartner *",
    contactRole: "Rolle",
    contactRolePlaceholder: "z.B. Geschäftsführer",
    contactEmail: "E-Mail",
    contactPhone: "Telefon",
    contactPhonePlaceholder: "+49 ...",
    additionalContacts: "Weitere Ansprechpartner",
    additionalContactsDesc: "Zusätzliche Kontaktpersonen in Ihrem Unternehmen",
    addContact: "Hinzufügen",
    createContact: "Kontakt anlegen",
    noContacts: "Noch keine weiteren Ansprechpartner",
    contactLabel: "Kontakt {{n}}",
    primaryContact: "Hauptkontakt",
    nameRequired: "Name *",
    emailRequired: "E-Mail *",
    tradesSection: "Gewerke & Leistungen",
    tradesLabel: "Gewerke",
    stackLabel: "Technologie-Stack",
    stackLoading: "Lädt Tags...",
    limitsSection: "Monatslimit",
    monthlyLimit: "Monatliches Limit",
    monthlyLimitDesc: "Maximale Anzahl an Projektanfragen pro Monat, die Sie erhalten möchten.",
    monthlyLimitUnit: "Projektanfragen / Monat",
    noProfile: "Kein Profil gefunden.",
    createProfile: "Profil erstellen",
    saved: "Profil gespeichert",
    saveError: "Fehler beim Speichern",
    notLoggedIn: "Nicht eingeloggt",
    saving: "Wird gespeichert...",
    saveBtn: "Profil speichern",
  },
  // ─── Legal: Datenschutz ───
  datenschutz: {
    seoTitle: "Datenschutzerklärung",
    seoDesc: "Datenschutzerklärung von CRAFTFINDUS. Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO.",
    title: "Datenschutzerklärung",
    s1Title: "1. Verantwortlicher",
    s1Intro: "Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) und anderer nationaler Datenschutzgesetze sowie sonstiger datenschutzrechtlicher Bestimmungen ist:",
    s2Title: "2. Allgemeines zur Datenverarbeitung",
    s2Text: "Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen Plattform sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung personenbezogener Daten erfolgt regelmäßig nur nach Einwilligung des Nutzers oder in Fällen, in denen eine vorherige Einholung einer Einwilligung aus tatsächlichen Gründen nicht möglich ist und die Verarbeitung der Daten durch gesetzliche Vorschriften gestattet ist.",
    s3Title: "3. Rechtsgrundlagen der Verarbeitung",
    s3a: "Art. 6 Abs. 1 lit. a DSGVO: Einwilligung der betroffenen Person",
    s3b: "Art. 6 Abs. 1 lit. b DSGVO: Verarbeitung zur Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen",
    s3c: "Art. 6 Abs. 1 lit. c DSGVO: Verarbeitung zur Erfüllung einer rechtlichen Verpflichtung",
    s3f: "Art. 6 Abs. 1 lit. f DSGVO: Verarbeitung zur Wahrung berechtigter Interessen",
    s4Title: "4. Bereitstellung der Plattform und Logfiles",
    s4Text1: "Bei jedem Aufruf unserer Plattform erfasst unser System automatisiert Daten und Informationen des aufrufenden Rechners. Folgende Daten werden hierbei erhoben:",
    s4Li1: "Browsertyp und verwendete Version",
    s4Li2: "Betriebssystem des Nutzers",
    s4Li3: "IP-Adresse des Nutzers (anonymisiert)",
    s4Li4: "Datum und Uhrzeit des Zugriffs",
    s4Li5: "Websites, von denen das System des Nutzers auf unsere Plattform gelangt (Referrer)",
    s4Text2: "Die Daten werden in den Logfiles unseres Systems gespeichert. Eine Speicherung dieser Daten zusammen mit anderen personenbezogenen Daten des Nutzers findet nicht statt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Die Speicherung in Logfiles erfolgt, um die Funktionsfähigkeit der Plattform sicherzustellen und zur Abwehr von Angriffen.",
    s5Title: "5. Registrierung und Nutzerkonto",
    s5Text1: "Auf unserer Plattform bieten wir Nutzern die Möglichkeit, sich unter Angabe personenbezogener Daten zu registrieren. Für Handwerksbetriebe umfasst dies insbesondere:",
    s5Li1: "E-Mail-Adresse",
    s5Li2: "Firmenname und Kontaktdaten",
    s5Li3: "Beschreibung der angebotenen Handwerksleistungen",
    s5Li4: "Regionale Verfügbarkeit und Spezialisierungen",
    s5Li5: "SEPA-Lastschriftmandat (IBAN, Kontoinhaber) für die Abrechnung",
    s5Text2: "Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO zur Durchführung vorvertraglicher Maßnahmen und zur Vertragserfüllung. Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.",
    s6Title: "6. Projektanfragen durch Auftraggeber",
    s6Text1: "Auftraggeber, die über {{brand}} eine Projektanfrage stellen, geben folgende Daten an:",
    s6Li1: "Art des Handwerksprojekts",
    s6Li2: "Objekttyp und Projektgröße",
    s6Li3: "Kontaktdaten (Name, E-Mail, Telefon)",
    s6Li4: "Standort / Region",
    s6Li5: "Dringlichkeit und Budget-Rahmen",
    s6Text2: "Diese Daten werden verwendet, um passende Handwerksbetriebe zu identifizieren und die Anfrage gezielt an 3 bis 5 qualifizierte Betriebe weiterzuleiten. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Vermittlung passender Handwerksleistungen).",
    s7Title: "7. Matching und Datenweitergabe an Handwerksbetriebe",
    s7Text1: "Im Rahmen des Matching-Prozesses werden Anfragedaten an ausgewählte, auf der Plattform registrierte Handwerksbetriebe weitergegeben. Die Weitergabe ist auf die für die Kontaktaufnahme und Angebotserstellung erforderlichen Daten beschränkt. Handwerksbetriebe erhalten erst nach Annahme einer Anfrage Zugang zu den vollständigen Kontaktdaten des Auftraggebers.",
    s7Text2: "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO. Die Weitergabe erfolgt ausschließlich im Rahmen des bestimmungsgemäßen Plattformzwecks.",
    s8Title: "8. Zahlungsdaten und Zahlungsmethoden",
    s8Text: "Für die Abrechnung von Leistungen gegenüber Handwerksbetrieben erheben wir Zahlungsdaten (IBAN, Kontoinhaber). Diese Daten werden ausschließlich zur Zahlungsabwicklung verwendet und gemäß den gesetzlichen Aufbewahrungsfristen (§ 147 AO, § 257 HGB) für bis zu 10 Jahre gespeichert. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.",
    s9Title: "9. Hosting und technische Infrastruktur",
    s9Text: "Unsere Plattform wird auf Servern innerhalb der Europäischen Union gehostet. Die Datenverarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO und ggf. Art. 28 DSGVO (Auftragsverarbeitung). Wir haben mit unseren Hosting-Anbietern Auftragsverarbeitungsverträge (AVV) geschlossen, die die datenschutzkonforme Verarbeitung Ihrer Daten sicherstellen.",
    s10Title: "10. Cookies",
    s10Text1: "Unsere Plattform verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden und die Ihr Browser speichert. Sie dienen dazu, unser Angebot nutzerfreundlicher und effektiver zu gestalten.",
    s10Text2: "Wir unterscheiden zwischen folgenden Cookie-Kategorien:",
    s10Necessary: "Notwendige Cookies: Diese Cookies sind für den Betrieb der Plattform erforderlich und können nicht deaktiviert werden. Sie umfassen z.\u00A0B. Cookies zur Authentifizierung, zur Speicherung Ihrer Cookie-Einstellungen und zur Sicherstellung der Plattformfunktionalität. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.",
    s10Analytics: "Analyse-Cookies: Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Plattform interagieren, indem sie Informationen anonym sammeln und melden. Sie werden nur mit Ihrer Einwilligung gesetzt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO.",
    s10Marketing: "Marketing-Cookies: Diese Cookies werden verwendet, um Besuchern relevante Werbung anzuzeigen. Sie werden nur mit Ihrer Einwilligung gesetzt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO.",
    s10Text3: "Beim ersten Besuch unserer Plattform werden Sie über ein Cookie-Banner über die Verwendung von Cookies informiert und um Ihre Einwilligung gebeten. Sie können Ihre Einstellungen jederzeit über das Cookie-Banner anpassen. Bereits gesetzte Cookies können Sie jederzeit über die Einstellungen Ihres Browsers löschen.",
    s11Title: "11. Google Analytics",
    s11Text1: "Wir nutzen auf unserer Plattform Google Analytics, einen Webanalysedienst der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland (\"Google\"). Google Analytics verwendet Cookies, die eine Analyse der Nutzung unserer Plattform ermöglichen. Die durch das Cookie erzeugten Informationen über Ihre Benutzung dieser Plattform werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert.",
    s11Text2: "Wir haben die IP-Anonymisierung aktiviert, sodass Ihre IP-Adresse von Google innerhalb der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt wird. Im Auftrag des Betreibers dieser Plattform wird Google diese Informationen benutzen, um die Nutzung der Plattform auszuwerten, um Reports über die Plattformaktivitäten zusammenzustellen und um weitere mit der Nutzung verbundene Dienstleistungen gegenüber dem Plattformbetreiber zu erbringen.",
    s11Text3: "Google Analytics wird nur aktiviert, wenn Sie über unser Cookie-Banner in die Nutzung von Analyse-Cookies eingewilligt haben. Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO (Einwilligung). Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, indem Sie Ihre Cookie-Einstellungen anpassen.",
    s11Text4: "Weitere Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der Datenschutzerklärung von Google:",
    s12Title: "12. SSL- bzw. TLS-Verschlüsselung",
    s12Text: "Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von \"http://\" auf \"https://\" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.",
    s13Title: "13. Rechte der betroffenen Personen",
    s13Intro: "Als betroffene Person haben Sie folgende Rechte:",
    s13Art15: "Auskunftsrecht (Art. 15 DSGVO): Sie haben das Recht, Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen.",
    s13Art16: "Recht auf Berichtigung (Art. 16 DSGVO): Sie haben das Recht, unverzüglich die Berichtigung unrichtiger Daten zu verlangen.",
    s13Art17: "Recht auf Löschung (Art. 17 DSGVO): Sie haben das Recht, die Löschung Ihrer Daten zu verlangen, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.",
    s13Art18: "Recht auf Einschränkung (Art. 18 DSGVO): Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer Daten zu verlangen.",
    s13Art20: "Recht auf Datenübertragbarkeit (Art. 20 DSGVO): Sie haben das Recht, Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten.",
    s13Art21: "Widerspruchsrecht (Art. 21 DSGVO): Sie haben das Recht, jederzeit gegen die Verarbeitung Ihrer Daten Widerspruch einzulegen, soweit die Verarbeitung auf Art. 6 Abs. 1 lit. f DSGVO beruht.",
    s13Art7: "Recht auf Widerruf (Art. 7 Abs. 3 DSGVO): Sie haben das Recht, eine erteilte Einwilligung jederzeit zu widerrufen.",
    s13Art77: "Beschwerderecht (Art. 77 DSGVO): Sie haben das Recht, sich bei einer Aufsichtsbehörde zu beschweren. Die zuständige Aufsichtsbehörde ist der Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen.",
    s14Title: "14. Datenlöschung und Speicherdauer",
    s14Text: "Personenbezogene Daten werden gelöscht oder gesperrt, sobald der Zweck der Speicherung entfällt. Eine darüber hinausgehende Speicherung erfolgt nur, wenn dies durch europäische oder nationale Rechtsvorschriften vorgesehen ist. In diesen Fällen werden die Daten gesperrt oder gelöscht, wenn die vorgeschriebene Speicherfrist abläuft.",
    s15Title: "15. Änderung der Datenschutzerklärung",
    s15Text1: "Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen umzusetzen. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.",
    s15Text2: "Stand: Februar 2026",
  },
  // ─── Legal: Impressum ───
  impressum: {
    seoTitle: "Impressum",
    seoDesc: "Impressum von CRAFTFINDUS. Angaben gemäß § 5 TMG. Alexander Wolfshohl, Solingen.",
    title: "Impressum",
    s1Title: "Angaben gemäß § 5 TMG",
    s2Title: "Kontakt",
    s3Title: "Haftung für Inhalte",
    s3Text: "Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.",
    s4Title: "Haftung für Links",
    s4Text: "Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.",
    s5Title: "Urheberrecht",
    s5Text: "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.",
  },
  // ─── Legal: Barrierefreiheit ───
  barrierefreiheit: {
    seoTitle: "Erklärung zur Barrierefreiheit",
    seoDesc: "Erklärung zur Barrierefreiheit von CRAFTFINDUS gemäß dem Barrierefreiheitsstärkungsgesetz (BFSG) und der BITV 2.0.",
    title: "Erklärung zur Barrierefreiheit",
    scopeTitle: "Geltungsbereich",
    scopeText: "Diese Erklärung zur Barrierefreiheit gilt für die öffentlich zugängliche Website",
    scopeSuffix: "der",
    compatTitle: "Stand der Vereinbarkeit",
    compatText1: "Diese Website ist weitgehend mit den Anforderungen des Barrierefreiheitsstärkungsgesetzes (BFSG) und der Barrierefreien-Informationstechnik-Verordnung (BITV 2.0) vereinbar, die auf Grundlage der Richtlinie (EU) 2019/882 (European Accessibility Act) erlassen wurden.",
    compatText2: "Wir orientieren uns an den Web Content Accessibility Guidelines (WCAG) 2.1 Stufe AA und arbeiten kontinuierlich daran, die Barrierefreiheit unserer Website zu verbessern.",
    measuresTitle: "Maßnahmen zur Barrierefreiheit",
    measure1: "Semantische HTML-Struktur mit korrekter Überschriftenhierarchie",
    measure2: "Vollständige Bedienbarkeit per Tastatur (inkl. Skip-Navigation)",
    measure3: "Ausreichende Farbkontraste gemäß WCAG 2.1 AA",
    measure4: "Alternativtexte für alle informativen Bilder",
    measure5: "Korrekte Formularbeschriftungen und Fehlermeldungen",
    measure6: "Unterstützung von Screenreadern durch ARIA-Attribute",
    measure7: "Respektierung der Nutzereinstellung \u201EBewegung reduzieren\u201C (prefers-reduced-motion)",
    measure8: "Responsive Design für verschiedene Geräte und Vergrößerungsstufen",
    limitationsTitle: "Bekannte Einschränkungen",
    limitationsIntro: "Trotz unserer Bemühungen können folgende Bereiche noch Einschränkungen aufweisen:",
    limitation1: "Ältere PDF-Dokumente sind möglicherweise nicht vollständig barrierefrei",
    limitation2: "Einige interaktive Diagramme im Operator-Bereich sind eingeschränkt per Tastatur bedienbar",
    limitationsOutro: "Wir arbeiten aktiv daran, diese Einschränkungen zu beheben.",
    feedbackTitle: "Feedback und Kontakt",
    feedbackIntro: "Sollten Sie auf Barrieren stoßen oder Verbesserungsvorschläge haben, kontaktieren Sie uns bitte:",
    feedbackResponse: "Wir bemühen uns, Ihr Anliegen innerhalb von 2 Wochen zu beantworten.",
    enforcementTitle: "Durchsetzungsverfahren",
    enforcementText: "Sollten Sie nach einer Kontaktaufnahme innerhalb einer angemessenen Frist keine zufriedenstellende Antwort erhalten, können Sie sich an die zuständige Durchsetzungsstelle wenden. Die zuständige Marktüberwachungsbehörde für das BFSG können Sie über die",
    enforcementLink: "Website des Bundesministeriums für Arbeit und Soziales",
    enforcementSuffix: "ermitteln.",
    createdTitle: "Erstellung dieser Erklärung",
    createdText: "Diese Erklärung wurde am 7. Februar 2026 erstellt und wird regelmäßig überprüft und aktualisiert.",
  },
  // ─── Suche Header ───
  sucheHeader: {
    cta: "Handwerksbetrieb finden",
    logoAlt: "CRAFTFINDUS | Handwerksbetrieb finden",
  },
  // ─── Leads Header ───
  leadsHeader: {
    cta: "Projektanfragen erhalten",
    ctaTooltip: "Sie entscheiden, welche Anfragen Sie annehmen",
    logoAlt: "CRAFTFINDUS | Qualifizierte Projektanfragen für Handwerksbetriebe",
  },
  // ─── Leads Footer ───
  leadsFooter: {
    imprint: "Impressum",
    privacy: "Datenschutz",
    contact: "Kontakt",
    faq: "FAQ",
    forCraft: "Für Handwerksbetriebe",
    motto: "Finden · Verbinden · Lösen",
  },
  // ─── Operator ───
  op: {
    // Layout & Nav
    loadingPortal: "Lade Operator-Portal...",
    portalLabel: "CRAFTFINDUS Operator",
    roleLabel: "Operator",
    ctaNewProvider: "Neuen Betrieb anlegen",
    ctaNewProviderDesc: "Handwerksbetrieb hinzufügen",
    navDashboard: "Dashboard",
    navRegistrations: "Registrierungen",
    navRequests: "Projektanfragen",
    navProviders: "Handwerksbetriebe",
    navOpportunities: "Projekt-Matching",
    navClaims: "Reklamationen",
    navBilling: "Abrechnung",
    navCosts: "Kostenübersicht",
    navPricing: "Pricing",
    navMatching: "Matching",
    navSettings: "Einstellungen",
    navAudit: "Audit-Log",
    navSales: "Sales Dashboard",
    navROI: "ROI-Rechner",
    navFeedback: "Feedback",
    // Dashboard
    dashTitle: "Dashboard",
    dashSubtitle: "Übersicht aller Aktivitäten",
    realtimeActive: "Realtime aktiv – Neue Anfragen werden automatisch gematched",
    realtimeConnecting: "Verbindung wird hergestellt…",
    kpiNew7d: "Neue Projekte (7T)",
    kpiDelivered7d: "Zugestellt (7T)",
    kpiFailed: "Fehlgeschlagen",
    kpiClaimsOpen: "Claims offen",
    kpiBlocked: "Betriebe gesperrt",
    kpiRevenue: "Umsatz (Monat)",
    liveMatching: "Live Matching",
    waitingForRequests: "Warte auf neue Anfragen…",
    recentRequests: "Letzte Projektanfragen",
    noRequests: "Keine Anfragen vorhanden",
    openClaims: "Offene Claims",
    noOpenClaims: "Keine offenen Claims",
    // Providers
    provTitle: "Betriebe",
    provSubtitle: "Handwerksbetriebe verwalten",
    filterAll: "Alle",
    filterActive: "Aktiv",
    filterPending: "Ausstehend",
    filterSuspended: "Gesperrt",
    filterPastDue: "Überfällig",
    createProvider: "+ Betrieb anlegen",
    colProvider: "Betrieb",
    colContact: "Kontakt",
    colRegion: "Region",
    colStatus: "Status",
    colBilling: "Billing",
    colSEPA: "SEPA",
    colMandate: "Mandat",
    colLimit: "Limit",
    colCreated: "Erstellt",
    statusActive: "Aktiv",
    statusPending: "Ausstehend",
    statusSuspended: "Gesperrt",
    noProviders: "Keine Betriebe gefunden",
    // Requests
    reqTitle: "Projektanfragen",
    reqSubtitle: "Alle eingegangenen Projektanfragen",
    reqDetailTitle: "Anfrage-Details",
    backToList: "Zurück zur Liste",
    filterUnmatched: "Nicht gematched",
    filterMatched: "Gematched",
    colNumber: "Nr.",
    colCategory: "Kategorie",
    colCompany: "Unternehmen",
    colUrgency: "Dringlichkeit",
    colPrice: "Preis",
    colDate: "Datum",
    matched: "Gematched",
    open: "Offen",
    catSupport: "Kleinreparatur",
    catManaged: "Wartungsvertrag",
    catProject: "Bauprojekt",
    catSecurity: "Notdienst",
    catCloud: "Sanierung",
    urgImmediate: "Sofort",
    urgWithin48h: "48 Stunden",
    urgWithin7d: "7 Tage",
    urgPlanned: "Geplant",
    decSelf: "Selbst",
    decTeam: "Team",
    decRecommend: "Empfehlung",
    labelCategory: "Kategorie",
    labelUrgency: "Dringlichkeit",
    labelRegion: "Region",
    labelRemote: "Remote",
    labelOnsite: "Vor-Ort",
    labelCompliance: "Compliance",
    labelDecision: "Entscheidung",
    labelBudget: "Budget",
    labelPrice: "Preis",
    labelProjectSize: "Projektgröße",
    labelSystems: "Systeme",
    labelUsers: "Nutzer",
    labelDescription: "Beschreibung",
    labelContext: "Kontext",
    labelStackTags: "Gewerke-Tags",
    labelOpportunities: "Opportunities",
    labelMatchRuns: "Match-Runs",
    labelRequester: "Anfragender",
    labelRiskFlags: "Risiko-Flags",
    selected: "ausgewählt",
    startMatching: "Matching starten",
    matchingRunning: "Matching läuft...",
    matchingStarted: "Matching gestartet",
    matchingFailed: "Matching fehlgeschlagen",
    deleteRequest: "Anfrage löschen",
    deleteRequestTitle: "Anfrage löschen?",
    deleteRequestDesc: "Die Anfrage <strong>{{number}}</strong> und alle zugehörigen Opportunities, Match-Runs und Daten werden unwiderruflich gelöscht.",
    cancelAction: "Abbrechen",
    deleting: "Wird gelöscht...",
    deleteForever: "Endgültig löschen",
    requestDeleted: "Anfrage {{number}} gelöscht",
    deleteError: "Fehler beim Löschen",
    loadError: "Fehler beim Laden der Anfragen",
    requestNotFound: "Anfrage nicht gefunden",
    // Registrations
    regTitle: "Registrierungen",
    regSubtitle: "Handwerksbetrieb-Registrierungen prüfen & verwalten",
    regFilterPending: "Ausstehend",
    regFilterApproved: "Freigegeben",
    regFilterRejected: "Abgelehnt",
    regFilterAll: "Alle",
    regNew: "Neu",
    regEmpty: "Keine Registrierungen in dieser Kategorie",
    regSelectHint: "Registrierung auswählen",
    regApproveSuccess: "Registrierung freigegeben – Zugangsdaten werden erstellt",
    regApproveError: "Fehler bei der Freigabe",
    regRejectSuccess: "Registrierung abgelehnt",
    regRejectError: "Fehler beim Ablehnen",
    regCreateSuccess: "Registrierung angelegt",
    regUpdateSuccess: "Registrierung aktualisiert",
    regDeleteSuccess: "Registrierung gelöscht",
    regDeleteError: "Fehler beim Löschen",
    regDeleteTitle: "Registrierung löschen?",
    regDeleteDesc: "Die Registrierung von {{name}} wird unwiderruflich gelöscht.",
    regDeleteConfirm: "Endgültig löschen",
    // Opportunities
    oppTitle: "Projekt-Matching",
    oppSubtitle: "Alle gematchten Projektanfragen überwachen",
    oppFilterNew: "Neu",
    oppFilterInReview: "In Prüfung",
    oppFilterFailed: "Failed",
    oppFilterHold: "Hold",
    oppColNumber: "Nr.",
    oppColCategory: "Kategorie",
    oppColProvider: "Betrieb",
    oppColScore: "Score",
    oppColStatus: "Status",
    oppColDelivery: "Delivery",
    oppColPrice: "Preis",
    oppEmpty: "Keine Anfragen",
    oppSelectHint: "Anfrage auswählen",
    oppResend: "Resend",
    oppResendSuccess: "Resend ausgelöst",
    oppDetailUrgency: "Dringlichkeit",
    oppDetailCompany: "Unternehmen (Anfrage)",
    oppDetailEmail: "E-Mail (Anfrage)",
    oppDetailLocation: "Standort",
    oppDetailHoldReason: "Hold Reason",
    // Claims
    claimTitle: "Claims / Reklamationen",
    claimSubtitle: "Reklamationen prüfen und entscheiden",
    claimFilterOpen: "Offen",
    claimFilterDecided: "Entschieden",
    claimEmpty: "Keine Claims",
    claimSelectHint: "Claim auswählen für Details",
    claimDetail: "Claim Detail",
    claimReason: "Grund",
    claimComment: "Kommentar",
    claimOppPrice: "Opportunity-Preis",
    claimSubmittedAt: "Eingereicht am",
    claimOperatorNote: "Operator-Notiz",
    claimCreditCents: "Gutschrift (Cents)",
    claimApprove: "Genehmigen",
    claimReject: "Ablehnen",
    claimApproveSuccess: "Claim genehmigt",
    claimRejectSuccess: "Claim abgelehnt",
    // Billing
    billingTitle: "Billing Monitor",
    billingSubtitle: "Abrechnungen, Mandate und Versandstatus",
    billingOverdue: "Überfällig",
    billingMandate: "Zahlungsmittel",
    billingEmailFailures: "E-Mail Fehler",
    billingMonthClose: "Monatsabschluss",
    billingInvoices: "Rechnungen",
    billingCloseMonth: "Monat abschließen",
    billingCloseSuccess: "Monat {{month}} abgeschlossen",
    billingEmpty: "Keine Einträge",
    billingOverdueSince: "Überfällig seit",
    billingMethods: "Methoden",
    billingError: "Fehler",
    billingAttempts: "Versuche",
    billingMonth: "Monat",
    billingAmount: "Betrag",
    billingNet: "Netto",
    billingGross: "Brutto",
    billingPeriod: "Periode",
    colBillingStatus: "Billing Status",
    // Cost Overview
    costTitle: "Kostenübersicht",
    costSubtitle: "Angenommene Projektanfragen pro Betrieb · Monatsabrechnung",
    costProviders: "Betriebe",
    costAccepted: "Angenommene Projektanfragen",
    costTotal: "Gesamtbetrag ({{month}})",
    costVatNote: "zzgl. MwSt. · Abrechnung zum Monatsende",
    costNoAccepted: "Keine angenommenen Projektanfragen in {{month}}",
    colAccepted: "Angenommen",
    colAmountNet: "Betrag (netto)",
    colAmountGross: "Betrag (brutto)",
    costTotalRow: "Gesamt",
    costFooter: "Alle Beträge in Euro · MwSt. 19% · Abrechnung erfolgt zum Ende des Kalendermonats",
    // Audit
    auditTitle: "Audit Log",
    auditSubtitle: "Globales Aktivitätsprotokoll",
    auditAllEntities: "Alle Entities",
    auditAllEvents: "Alle Events",
    auditRetention: "Retention",
    auditCSV: "CSV Export",
    auditRetentionLabel: "Einträge automatisch löschen nach:",
    auditDays: "Tage",
    auditSaved: "Aufbewahrungsfrist auf {{days}} Tage gesetzt",
    auditPurgeConfirm: "Alle Audit-Log-Einträge älter als {{days}} Tage jetzt löschen?",
    auditPurged: "Alte Einträge gelöscht",
    auditPurgeNow: "Jetzt bereinigen",
    auditCurrentRetention: "Aktuell gespeichert: <span>{{days}} Tage</span>. Zum automatischen Löschen kann ein Cron-Job konfiguriert werden.",
    colTimestamp: "Zeitstempel",
    colEvent: "Event",
    colEntity: "Entity",
    colActor: "Actor",
    colMeta: "Meta",
    auditEntries: "{{count}} Einträge · Seite {{page}} von {{total}}",
    // Settings
    setTitle: "Einstellungen",
    setSubtitle: "Plattform-Konfiguration",
    setProviderTemplates: "Betrieb-Templates",
    setCustomerTemplates: "Endkunden-Templates",
    setGraph: "Microsoft Graph",
    setUsers: "Benutzerverwaltung",
    setApiKeys: "API-Schlüssel",
    setSaveTemplates: "Templates speichern",
    setTemplatesSaved: "E-Mail-Templates gespeichert",
    setGraphTitle: "Microsoft Graph API",
    setGraphDesc: "Konfiguration für den E-Mail-Versand via Graph API (Mail.Send)",
    setTenantId: "Tenant ID",
    setClientId: "Client ID",
    setClientSecret: "Client Secret",
    setSenderEmail: "Absender E-Mail",
    setRetryPolicy: "Retry-Policy",
    setMaxAttempts: "Max. Versuche",
    setIntervals: "Intervalle (Min)",
    setIntervalsHint: "Komma-getrennt, z.B. 5,10,30",
    setSaveGraph: "Graph-Einstellungen speichern",
    setSavingGraph: "Wird gespeichert...",
    setGraphSaved: "Microsoft Graph Einstellungen gespeichert",
    setTestEmail: "Test-E-Mail senden",
    setTestTitle: "Test-E-Mail senden",
    setTestDesc: "Geben Sie die Empfänger-Adresse ein, an die eine Test-E-Mail über Microsoft Graph gesendet werden soll.",
    setTestRecipient: "Empfänger E-Mail",
    setTestSending: "Wird gesendet...",
    setTestSend: "Senden",
    setTestSent: "Test-E-Mail an {{email}} gesendet",
    // Profile
    profileTitle: "Mein Profil",
    profileSubtitle: "Persönliche Einstellungen und Sicherheit",
    profileRole: "Operator-Zugang",
    profileDisplayName: "Anzeigename",
    profileNamePlaceholder: "Ihr Name",
    profileSaveName: "Name speichern",
    profileNameSuccess: "Name gespeichert",
    profileNameError: "Fehler beim Speichern",
    profileChangePassword: "Kennwort ändern",
    profileNewPassword: "Neues Kennwort",
    profilePasswordPlaceholder: "Mindestens 6 Zeichen",
    profileConfirmPassword: "Kennwort bestätigen",
    profileConfirmPlaceholder: "Kennwort wiederholen",
    profilePasswordSuccess: "Kennwort erfolgreich geändert",
    profilePasswordError: "Fehler beim Ändern des Kennworts",
    profilePasswordMinLength: "Passwort muss mindestens 6 Zeichen haben",
    profilePasswordMismatch: "Passwörter stimmen nicht überein",
    profileAccountDetails: "Account-Details",
    profileEmail: "E-Mail",
    profileCreatedAt: "Account erstellt",
    profileLastLogin: "Letzte Anmeldung",
    // Pricing
    pricTitle: "Pricing",
    pricSubtitle: "Abo-Pläne, Add-ons & Preiskonfiguration",
    pricPlans: "Abo-Pläne",
    pricAddons: "Add-ons",
    pricPreview: "Preview Pricing Page",
    pricNewPlan: "Neuer Plan",
    pricEditPlan: "Plan bearbeiten",
    pricPlanSaved: "Plan gespeichert",
    pricPlanDeleted: "Plan gelöscht",
    pricDeleteConfirm: "Plan löschen?",
    pricNewAddon: "Neues Add-on",
    pricEditAddon: "Add-on bearbeiten",
    pricAddonSaved: "Add-on gespeichert",
    pricAddonDeleted: "Add-on gelöscht",
    pricKey: "Key",
    pricName: "Name",
    pricPriceCents: "Preis (Cent)",
    pricInclLeads: "Inkl. Leads",
    pricMaxDeliveries: "Max. Zustellungen",
    pricMaxRadius: "Max. Radius (km)",
    pricMaxTrades: "Max. Gewerke",
    pricSort: "Sortierung",
    pricFeaturesJSON: "Features (JSON Array)",
    pricActiveLabel: "Aktiv",
    pricInactive: "Inaktiv",
    pricEdit: "Bearbeiten",
    pricExtraLeads: "Extra Leads",
    // Matching
    matchTitle: "Matching",
    matchSubtitle: "Matching-Engine Konfiguration",
    matchWeights: "Gewichtung",
    matchLimits: "Limits & Fairness",
    matchAI: "AI Matching",
    matchScoreWeights: "Score-Gewichtung",
    matchScoreDesc: "Verteilung der 100 Punkte auf die Matching-Dimensionen.",
    matchCurrent: "Aktuell:",
    matchStackMatch: "Gewerke-Match",
    matchStackMatchDesc: "Übereinstimmung zwischen Betriebsprofil und Projektanfrage",
    matchUrgencyFit: "SLA / Dringlichkeit",
    matchUrgencyFitDesc: "SLA-Reaktionszeit vs. Dringlichkeit der Anfrage",
    matchGeoFit: "Geographie",
    matchGeoFitDesc: "Standort- und Remote-Übereinstimmung",
    matchReliability: "Zuverlässigkeit",
    matchReliabilityDesc: "Annahme-Quote und Reaktionszeit des Betriebs",
    matchQuality: "Qualität",
    matchQualityDesc: "Interner Quality Score des Betriebs",
    matchLimitsTitle: "Limits & Fairness",
    matchLimitsDesc: "Steuerung der Betrieb-Auswahl und Fairness-Regeln",
    matchMaxProviders: "Max. Betriebe pro Anfrage",
    matchMaxProvidersDesc: "Wie viele Betriebe pro Anfrage gematched werden",
    matchMinScore: "Min. Score-Schwelle",
    matchMinScoreDesc: "Betriebe unter diesem Score werden ausgeschlossen",
    matchFairnessDelta: "Fairness-Delta",
    matchFairnessDeltaDesc: "Punktedifferenz für Fairness-Rotation",
    matchExpiryHours: "Ablaufzeit (Stunden)",
    matchExpiryDesc: "Anfrage verfällt nach dieser Zeit",
    matchOverage: "Überschreitungstoleranz (%)",
    matchOverageDesc: "= Betrieb darf sein Monatslimit um {{percent}}% überschreiten",
    matchOverageExample: "Beispiel: Bei Limit 20 und 20% Toleranz kann der Betrieb bis zu 24 Anfragen annehmen",
    matchSaveConfig: "Konfiguration speichern",
    matchSaving: "Wird gespeichert...",
    matchSaved: "Matching-Konfiguration gespeichert",
    matchWeightError: "Gewichtung muss 100 ergeben (aktuell: {{total}})",
    matchAITitle: "AI-Enhanced Matching",
    matchAIDesc: "KI-gestützte Analyse und Bewertung von Anfragen",
    matchAIModel: "AI-Modell",
    matchAIFunctions: "AI-Funktionen",
    matchAIEnhanceReasons: "Match-Begründungen verbessern",
    matchAIEnhanceReasonsDesc: "AI generiert detaillierte Erklärungen warum ein Betrieb passt",
    matchAIAdjustScores: "Score-Anpassungen",
    matchAIAdjustScoresDesc: "AI kann Scores basierend auf Kontextanalyse anpassen",
    matchAIMaxAdjustment: "Max. Score-Anpassung (±)",
    matchAIMaxAdjustmentDesc: "Maximale Punkte die AI zum Score addieren/subtrahieren darf",
    matchAIHowTitle: "Wie AI-Matching funktioniert",
    // Feedback
    fbTitle: "Feedback",
    fbSubtitle: "Kundenfeedback verwalten und versenden",
    fbRequests: "Anfragen",
    fbConfig: "Konfiguration",
    fbWonWithout: "Gewonnene Anfragen ohne Feedback ({{count}})",
    fbSend: "Senden",
    fbEmailSent: "Feedback-E-Mail gesendet",
    fbAllRequests: "Alle Feedback-Anfragen",
    fbNoRequests: "Noch keine Feedback-Anfragen erstellt.",
    fbResend: "Erneut senden",
    fbEmailResent: "E-Mail erneut gesendet",
    fbResponses: "Antworten",
    fbNoResponses: "Keine Antworten.",
    fbConfigDesc: "Konfigurieren Sie die Fragen, die Kunden im Feedback-Formular sehen.",
    fbEditQuestion: "Frage bearbeiten",
    fbNewQuestion: "Neue Frage erstellen",
    fbQuestionText: "Fragetext",
    fbType: "Typ",
    fbTypeRating: "Sterne-Bewertung",
    fbTypeText: "Freitext",
    fbTypeYesNo: "Ja/Nein",
    fbTypeScale: "Skala (1-10)",
    fbSaved: "Gespeichert",
    // Sales
    salesTitle: "Sales Dashboard",
    salesSubtitle: "KPIs & Argumentationshilfen für den Vertrieb",
    salesTotalProviders: "Betriebe gesamt",
    salesActiveProviders: "Aktive Betriebe",
    salesNewRegs7d: "Neue Registrierungen (7T)",
    salesAvgAcceptance: "Ø Annahmequote",
    salesOpps30d: "Opportunities (30T)",
    salesDelivered30d: "Delivered (30T)",
    salesRevenue: "Umsatz (Monat)",
    salesAvgScore: "Ø Match-Score",
    salesElevatorPitch: "Elevator Pitch (30 Sek.)",
    salesCopy: "Kopieren",
    salesCopied: "Kopiert",
    salesTop5: "Top 5 Verkaufsargumente",
    salesArgRiskFree: "Risikofrei",
    salesArgRiskFreeDesc: "Keine Verträge, keine Grundgebühr, Zahlung nur bei Annahme",
    salesArgQuality: "Qualität",
    salesArgQualityDesc: "Vorqualifizierte Anfragen, algorithmus-basiertes Matching",
    salesArgFairness: "Fairness",
    salesArgFairnessDesc: "Max. 3–5 Mitbewerber, kein Preiskampf",
    salesArgFast: "Schnell",
    salesArgFastDesc: "In 15 Minuten registriert, erste Leads in Stunden",
    salesArgFlexible: "Flexibel",
    salesArgFlexibleDesc: "Wöchentliches Limit einstellbar, jederzeit pausierbar",
    salesStrongestNumbers: "Die 3 stärksten Zahlen",
    salesAcceptanceRate: "Annahme-Quote",
    salesResponseTime: "Ø Reaktionszeit",
    salesProvidersPerRequest: "Handwerker pro Anfrage",
    salesObjectionHandling: "Einwandbehandlung",
    salesBenchmarks: "Betrieb-KPI Benchmarks (für Argumentation)",
    salesKPI: "KPI",
    salesBenchmark: "CRAFTFINDUS-Benchmark",
    // ROI
    roiTitle: "ROI-Rechner",
    roiSubtitle: "Interaktiver Rechner für Verkaufsgespräche",
    roiParams: "Parameter anpassen",
    roiLeadsPerMonth: "Leads pro Monat",
    roiAvgLeadPrice: "Ø Lead-Preis (€)",
    roiConversion: "Conversion-Rate Lead → Kunde (%)",
    roiAvgDealValue: "Ø Auftragswert (€)",
    roiCurrentCAC: "Aktuelle Akquisekosten pro Neukunde (€)",
    roiIndustryAvg: "Branchendurchschnitt: 1.500–3.000 €",
    roiScenarios: "Schnellszenarien",
    roiMonthlyCost: "Monatliche CRAFTFINDUS-Kosten",
    roiExpectedCustomers: "Erwartete Neukunden",
    roiExpectedRevenue: "Erwarteter Umsatz",
    roiLabel: "ROI",
    roiCACComparison: "Akquisekosten-Vergleich",
    roiCurrentCACLabel: "Aktueller CAC",
    roiCraftfindusCAC: "CRAFTFINDUS CAC",
    roiSavingsPerCustomer: "Ersparnis pro Neukunde",
    roiCurrent: "Aktuell",
    roiWithCraftfindus: "Mit CRAFTFINDUS",
    roiAnnualSavings: "Jährliche Ersparnis bei Akquisekosten",
    roiBasedOn: "Basierend auf {{count}} Neukunden/Jahr",
    roiTalkingPoint: "Gesprächshilfe",
    roiTalkingPointText: "Wenn Sie {{leads}} Leads pro Monat zu durchschnittlich {{price}} € annehmen, kostet Sie das {{cost}} € im Monat. Bei einer Conversion-Rate von {{conv}} % und einem durchschnittlichen Auftragswert von {{deal}} € ergibt das einen erwarteten Umsatz von {{revenue}} € – ein ROI von {{roi}} %.",
    roiScenarioFreelancer: "Freelancer (klein)",
    roiScenarioMedium: "Systemhaus (mittel)",
    roiScenarioLarge: "MSP (groß)",
    // Sales
    salesElevatorPitchText: "CRAFTFINDUS liefert Handwerksbetrieben vorqualifizierte Projektanfragen, die exakt zum eigenen Profil passen. Statt Kaltakquise oder Bieterportale erhalten Sie Leads, bei denen Sie maximal gegen 4 andere Betriebe antreten – und zahlen nur, wenn Sie den Lead aktiv annehmen. Keine Verträge, kein Risiko, sofort startklar.",
    salesObj1Q: "Das ist mir zu teuer.",
    salesObj1A: "Was kostet Sie heute ein qualifizierter Neukunde? Die meisten Handwerksbetriebe liegen bei 1.500–3.000 €. Ein CRAFTFINDUS-Lead kostet ab 39 € – vorqualifiziert. Das ist kein Aufwand, das ist eine Investition mit sofortigem ROI.",
    salesObj2Q: "Wir haben genug Kunden durch Empfehlungen.",
    salesObj2A: "Empfehlungen sind der beste Kanal – aber nicht planbar und nicht skalierbar. CRAFTFINDUS ergänzt Ihren bestehenden Zufluss mit planbaren, qualifizierten Projektanfragen.",
    salesObj3Q: "Lead-Portale haben bei uns nie funktioniert.",
    salesObj3A: "Klassische Portale verteilen an 20–50 Anbieter. Bei uns max. 5. Algorithmus-basiert, nicht keyword-basiert. Fundamental anderer Ansatz.",
    salesObj4Q: "Ich möchte erst mal testen.",
    salesObj4A: "Genau dafür gemacht. Keine Vertragsbindung, keine Grundgebühr, keine Mindestlaufzeit. Null Risiko.",
    salesObj5Q: "Woher weiß ich, dass die Leads qualifiziert sind?",
    salesObj5A: "Jede Anfrage durchläuft einen strukturierten Wizard + Risk-Scoring. Sie sehen alle Details inkl. Match-Score vor der Entscheidung. Plus Claim-Verfahren bei unpassenden Leads.",
    salesBenchCostPerLead: "Kosten pro qualifiziertem Lead",
    salesBenchConvChat: "Conversion Lead → Erstgespräch",
    salesBenchConvCustomer: "Conversion Lead → Kunde",
    salesBenchCAC: "Customer Acquisition Cost",
    // Provider Detail
    pdTabProfile: "Profil & Status",
    pdTabServices: "Services & Stack",
    pdMasterData: "Stammdaten",
    pdContact: "Kontakt",
    pdPhone: "Telefon",
    pdWebsite: "Website",
    pdCompanyType: "Unternehmensart",
    pdRemote: "Remote",
    pdSLA: "SLA",
    pdMonthlyLimit: "Monatslimit",
    pdAddress: "Adresse",
    pdResendWelcome: "Welcome-Mail erneut senden",
    pdResetPassword: "Passwort zurücksetzen",
    pdAdditionalContacts: "Weitere Ansprechpartner",
    pdStatusActions: "Status & Aktionen",
    pdApproved: "Genehmigt",
    pdSuspended: "Gesperrt",
    pdSuspendReason: "Sperrgrund:",
    pdSuspendedAt: "Gesperrt am:",
    pdFailedDebits: "Fehlgeschlagene Lastschriften:",
    pdApprove: "Freischalten",
    pdSuspend: "Manuell sperren",
    pdSuspendPrompt: "Grund für die Sperre:",
    pdUnsuspend: "Entsperren",
    pdDelete: "Löschen",
    pdDeleteTitle: "Handwerksbetrieb löschen?",
    pdDeleteDesc: "<strong>{{company}}</strong> wird unwiderruflich gelöscht. Alle zugehörigen Daten (Projektanfragen, Rechnungen, Benutzer) werden entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
    pdDeleted: "Handwerksbetrieb gelöscht",
    pdPayment: "Zahlungsmittel (Mollie)",
    pdPaymentStatus: "Status",
    pdSetupStatus: "Setup-Status",
    pdMollieCustomer: "Mollie Customer",
    pdPaymentMethods: "Methoden",
    pdActivateManual: "Manuell aktivieren",
    pdDeactivateManual: "Manuell deaktivieren",
    pdPaymentUpdated: "Zahlungsstatus aktualisiert",
    pdActionSuccess: "Aktion {{action}} erfolgreich",
    pdCategories: "Kategorien",
    pdNoCategories: "Keine Kategorien zugewiesen",
    pdStack: "Stack / Gewerke",
    pdNoStack: "Keine Stack-Tags zugewiesen",
    pdAuditLog: "Aktivitätsprotokoll",
    pdNoAuditLog: "Keine Aktivitäten",
    // Provider Detail - Trust & KPIs
    pdTrustKPIs: "Trust & KPIs",
    pdServiceSettings: "Service-Einstellungen",
    pdTrustProfile: "Trust-Profil",
    pdTrustLevel: "Level {{level}}",
    pdTrustScore: "Trust-Score: {{score}} / 100",
    pdTrustGewerbeanmeldung: "Gewerbeanmeldung geprüft",
    pdTrustVersicherung: "Betriebshaftpflicht bestätigt",
    pdTrustBonitaet: "Bonitätsprüfung bestanden",
    pdTrustIdentitaet: "Identitätsprüfung bestanden",
    pdTrustRequiredLevel: "Erforderlich für Level {{level}}",
    pdTrustActivated: "{{label}}: Aktiviert",
    pdTrustDeactivated: "{{label}}: Deaktiviert",
    pdActiveBadges: "Aktive Badges",
    pdBadgeVerifiedBusiness: "Geprüfter Betrieb",
    pdBadgeInsured: "Versichert",
    pdBadgePremium: "Premium Partner",
    pdBadgeTopRated: "Top bewertet",
    pdBadgeFastResponse: "Schnelle Reaktion",
    pdBadgeHighAcceptance: "Hohe Annahmequote",
    pdKPIs: "Leistungsdaten",
    pdLeadsReceived: "Leads erhalten",
    pdLeadsWon: "Leads gewonnen",
    pdConversionRate: "Abschlussquote",
    pdDisputeRate: "Reklamationsrate",
    pdAcceptanceRate: "Annahmequote",
    pdAvgResponseTime: "Ø Reaktionszeit",
    pdBillingModel: "Billing Modell",
    pdBillingModelSub: "Abo",
    pdBillingModelPPC: "PPC",
    pdAvgLeadScore: "Ø Lead-Score",
    pdLimitSet: "Monatslimit auf {{limit}} gesetzt",
    pdUnsuspendReason: "Entsperrt durch Operator",
    pdCatManagedService: "Wartung & Pflege",
    pdCatProject: "Handwerksprojekt",
    pdCatSecurity: "Sicherheit",
    pdCatCloud: "Neubau & Installation",
    pdCatSupport: "Reparatur & Notdienst",
    // Feedback extra
    fbSentAt: "Gesendet: {{date}}",
    fbKeyPlaceholder: "z.B. new_question",
    // Mollie Diagnostics page
    diagTitle: "Mollie Diagnostik",
    diagSubtitle: "Vollständige Validierung der Zahlungsintegration",
    // Provider Create
    createTitle: "Betrieb anlegen",
    createSubtitle: "Neuen Handwerksbetrieb onboarden",
    createSubmit: "Betrieb anlegen",
    createSuccess: "Handwerksbetrieb angelegt",
    createError: "Fehler beim Anlegen",
    createRequiredFields: "Pflichtfelder ausfüllen (Unternehmen, Kontakt, E-Mail)",
    createLoginEmailRequired: "Login-E-Mail für den Portalzugang angeben",
    // Months
    monthJan: "Januar",
    monthFeb: "Februar",
    monthMar: "März",
    monthApr: "April",
    monthMay: "Mai",
    monthJun: "Juni",
    monthJul: "Juli",
    monthAug: "August",
    monthSep: "September",
    monthOct: "Oktober",
    monthNov: "November",
    monthDec: "Dezember",
    // Mollie Settings
    setMollieTitle: "Mollie Payment Integration",
    setMollieDesc: "API-Schlüssel und Profil-ID für die Mollie-Zahlungsintegration. Diese Werte werden sicher in der Datenbank gespeichert und von allen Backend-Funktionen verwendet.",
    setMollieApiKey: "Mollie API Key",
    setMollieKeyHint: "Test-Key beginnt mit test_, Live-Key mit live_",
    setMollieProfileId: "Mollie Profile ID",
    setMollieProfileHint: "Dient zur Multi-Company-Isolation (Sicherheits-Check)",
    setMollieSave: "Speichern",
    setMollieSaving: "Speichern…",
    setMollieSaved: "Mollie-Einstellungen gespeichert",
    setMollieTestBtn: "Verbindung testen",
    setMollieTesting: "Teste…",
    setMollieTestFail: "Verbindung fehlgeschlagen",
    setMollieDiag: "Mollie Diagnostik",
  },
  // ─── Mollie Diagnostics ───
  mollieDiag: {
    allPassed: "Alle Checks bestanden",
    warningsFound: "Warnungen vorhanden",
    errorsFound: "Fehler erkannt",
    summaryPassed: "{{passed}}/{{total}} bestanden · {{warnings}} Warnungen · {{failed}} Fehler",
    refresh: "Aktualisieren",
    simulateWebhook: "Webhook simulieren",
    webhookSimulated: "Webhook simuliert: {{id}}",
    reconcilePending: "Pending abgleichen",
    reconciled: "{{reconciled}} von {{total}} abgeglichen",
    auditExport: "Audit Log exportieren",
    auditExported: "{{count}} Einträge exportiert",
    stateMachineTitle: "State Machine – Billing & Mandate",
    providerBillingStatus: "Provider Billing Status",
    paymentSetupStatus: "Payment Setup Status",
    webhookProcessing: "Webhook Processing",
    lastCheck: "Letzter Check:",
    secrets: "Secrets & Konfiguration",
    mollieConnectivity: "Mollie API Verbindung",
    profileIsolation: "Multi-Company Isolation",
    webhooks: "Webhook Events (letzte 20)",
    providerPayments: "Provider Zahlungsmethoden",
    subscriptions: "Abonnements",
    billingCurrentMonth: "Abrechnung aktueller Monat",
    securityEvents: "Sicherheitsereignisse",
    deliveryGuards: "Delivery Guards",
    notAuthenticated: "Nicht authentifiziert",
    requestFailed: "Anfrage fehlgeschlagen",
  },
  // ─── Avatar Picker ───
  avatarPicker: {
    changeAvatar: "Avatar ändern",
    selectAvatar: "Avatar auswählen",
    uploadImage: "Bild hochladen",
    dragOrClick: "Bild auswählen oder hierher ziehen",
    maxSize: "Max. 2 MB · JPG, PNG, WebP",
    uploading: "Wird hochgeladen...",
    onlyImages: "Nur Bilddateien erlaubt",
    maxFileSize: "Maximale Dateigröße: 2 MB",
    uploaded: "Avatar hochgeladen",
    uploadFailed: "Upload fehlgeschlagen",
    saved: "Avatar gespeichert",
    saveFailed: "Fehler beim Speichern",
  },
  // ─── Email Template Editor ───
  emailEditor: {
    subject: "Betreff",
    content: "Inhalt",
    preview: "Vorschau",
    availablePlaceholders: "Verfügbare Platzhalter",
  },
  // ─── Registration Detail ───
  regDetail: {
    legalName: "Rechtl. Name",
    phone: "Telefon",
    website: "Website",
    invoiceEmail: "Rechnungs-E-Mail",
    address: "Adresse",
    vatId: "USt-IdNr.",
    mainRegion: "Hauptregion",
    categories: "Kategorien",
    serviceRegions: "Service-Regionen",
    sla: "SLA",
    weeklyLimit: "Wochenlimit",
    remote: "Remote",
    reviewerNotes: "Interne Notizen",
    additionalContacts: "Weitere Kontakte",
    approveBtn: "Freigeben & Account erstellen",
    approving: "Wird freigegeben...",
    rejectBtn: "Ablehnen",
    approvedMsg: "Freigegeben – Provider-Account wurde erstellt",
    statusPending: "Ausstehend",
    statusApproved: "Freigegeben",
    statusRejected: "Abgelehnt",
  },
  // ─── Operator Header ───
  opHeader: {
    clockSuffix: "Uhr",
  },
  // ─── AI Search Optimization ───
  aiSearch: {
    title: "Was ist CRAFTFINDUS?",
    definition: "CRAFTFINDUS ist eine digitale Qualitätsplattform zur Vermittlung geprüfter Handwerksbetriebe in Deutschland, Österreich, der Schweiz, den Niederlanden, Belgien, Frankreich und Polen. Auftraggeber beschreiben ihr Projekt – CRAFTFINDUS findet durch intelligentes Matching 3 bis 5 passende, verifizierte Fachbetriebe aus der Region. Der Service ist für Auftraggeber kostenlos und unverbindlich. Handwerksbetriebe zahlen einen transparenten Fixpreis pro angenommenem Kontakt – ohne Provisionen, ohne Vertragsbindung.",
    highlight1: "Geprüfte Betriebe: Gewerbeanmeldung, Versicherung, Bonität verifiziert",
    highlight2: "Max. 3–5 Betriebe pro Projekt: Faire Chancen, kein Preiskampf",
    highlight3: "Transparente Preise: Feste Kontaktpreise, keine versteckten Gebühren",
    highlight4: "Fairer Reklamationsprozess: Erstattung bei unqualifizierten Kontakten",
  },
  // ─── SEO Landing Pages ───
  seoLanding: {
    verified: "Geprüfte Betriebe",
    free: "Kostenlos & unverbindlich",
    fast: "Antwort in 24h",
    ctaRequest: "Jetzt Anfrage stellen",
    freeForClients: "Kostenlos für Auftraggeber",
    whatIsCraftfindus: "Was ist CRAFTFINDUS?",
    whatIsCraftfindusText: "CRAFTFINDUS ist eine digitale Plattform zur Vermittlung geprüfter Handwerksbetriebe in Deutschland, Österreich, der Schweiz, Belgien, den Niederlanden, Frankreich und Polen. Sie beschreiben Ihr Projekt – wir finden 3 bis 5 passende Fachbetriebe in Ihrer Region. Kostenlos und unverbindlich für Auftraggeber.",
    verifiedProviders: "Geprüfte {{trade}} in {{city}}",
    howItWorks: "So funktioniert CRAFTFINDUS",
    costs: "{{trade}} Kosten & Preise",
    inCity: "in {{city}}",
    faq: "Häufige Fragen",
    ctaHeading: "{{trade}} in {{city}} gesucht?",
    ctaSubtext: "Stellen Sie jetzt Ihre kostenlose Anfrage und erhalten Sie bis zu 5 Angebote von geprüften Betrieben.",
    relatedCities: "{{trade}} in weiteren Städten",
    otherTrades: "Weitere Gewerke in {{city}}",
    relatedArticles: "Passende Ratgeber-Artikel",
  },
  // ─── Blog ───
  blog: {
    title: "CRAFTFINDUS Ratgeber",
    description: "Tipps, Kosten und Ratgeber rund um Handwerksprojekte",
    noPosts: "Noch keine Beiträge vorhanden.",
    backToList: "Zurück zum Ratgeber",
  },
  // ─── Warum CRAFTFINDUS ───
  warum: {
    seoTitle: "Warum CRAFTFINDUS – Die Qualitätsplattform für Handwerksvermittlung",
    seoDesc: "Erfahren Sie, warum CRAFTFINDUS anders ist: Lead-Qualitätsprüfung, transparente Preise, verifizierte Betriebe und fairer Reklamationsprozess.",
    heroLabel: "Warum CRAFTFINDUS",
    heroTitle1: "Handwerksvermittlung,",
    heroTitle2: "wie sie sein sollte.",
    heroDesc: "Die meisten Plattformen verteilen Kontakte. Wir vermitteln qualifizierte Projekte an geprüfte Betriebe – fair, transparent und outcome-optimiert.",
    problemLabel: "Das Marktproblem",
    problemTitle: "Was bei anderen Plattformen schiefläuft",
    problem1Title: "Unqualifizierte Anfragen",
    problem1Desc: "Kontakte ohne Budget, ohne echtes Projekt, ohne verifizierte Daten. Sie zahlen für Leads, die nie zu Aufträgen werden.",
    problem2Title: "Intransparente Kosten",
    problem2Desc: "Versteckte Gebühren, Provisionen auf Aufträge, unklare Preismodelle. Sie wissen nie genau, was Sie wirklich zahlen.",
    problem3Title: "Massenverteilung",
    problem3Desc: "Ihre Anfrage geht an 10, 15 oder 20 Betriebe gleichzeitig. Das Ergebnis: Preiskampf, Copy-Paste-Angebote, Frustration.",
    problem4Title: "Kein Reklamationsrecht",
    problem4Desc: "Kontakt nicht erreichbar? Falsches Gewerk? Pech gehabt. Bei den meisten Plattformen gibt es keine faire Lösung.",
    solutionLabel: "Unser Ansatz",
    solutionTitle: "Was CRAFTFINDUS anders macht",
    solution1Title: "Lead-Qualitätsscore",
    solution1Desc: "Jede Anfrage wird automatisch bewertet: Telefon verifiziert, Budget angegeben, Beschreibung vorhanden. Nur Anfragen mit Score > 60 werden abgerechnet.",
    solution2Title: "Transparente Kontaktpreise",
    solution2Desc: "Feste Preise pro Kontakt – vorab sichtbar. Keine Provisionen, keine versteckten Gebühren. Sie wissen immer, was Sie zahlen.",
    solution3Title: "Max. 3-5 Betriebe pro Projekt",
    solution3Desc: "Jede Anfrage geht an maximal 5 geprüfte Betriebe. Weniger Wettbewerb, höhere Abschlussquoten, faire Chancen.",
    solution4Title: "Fairer Reklamationsprozess",
    solution4Desc: "Kontakt nicht erreichbar? Falsches Gewerk? Sie erhalten Ihren Kontaktpreis zurück – innerhalb von 72 Stunden, garantiert.",
    solution5Title: "Verifizierte Betriebe",
    solution5Desc: "Gewerbeanmeldung, Versicherung, Bonität – unsere Betriebe durchlaufen einen mehrstufigen Verifizierungsprozess.",
    solution6Title: "Fairness-Mechanismus",
    solution6Desc: "Automatische Missbrauchserkennung, Transparenz-Dashboard und maximale Reklamationsquoten schützen die Plattformqualität.",
    ctaTitle: "Überzeugt?",
    ctaClientBtn: "Projekt professionell starten",
    ctaProviderBtn: "Mehr qualifizierte Projekte sichern",
  },
  // ─── Inquiry Psychology ───
  inquiryPsych: {
    qualityHint: "Je genauer Ihre Angaben, desto bessere Betriebe erhalten Sie.",
    timePromise: "Dauert weniger als 2 Minuten",
    matchingHint: "Wir prüfen Ihre Anfrage, bevor sie an passende Fachbetriebe weitergeleitet wird.",
    descShort: "Bitte beschreiben Sie Ihr Projekt etwas ausführlicher.",
    descGood: "Sehr gute Beschreibung – das erhöht Ihre Chancen auf schnelle Angebote.",
    photoHint: "Fotos helfen bei einer präzisen Einschätzung.",
  },
  // ─── Qualitätsversprechen ───
  quality: {
    seoTitle: "Qualitätsversprechen – So funktioniert CRAFTFINDUS",
    seoDesc: "Erfahren Sie transparent, wie wir Projekte prüfen, Betriebe verifizieren, fair abrechnen und Reklamationen bearbeiten.",
    heroLabel: "Unser Qualitätsversprechen",
    heroTitle1: "Transparenz.",
    heroTitle2: "Nicht nur ein Versprechen.",
    heroDesc: "Wir erklären Ihnen genau, wie unsere Plattform funktioniert – von der Projektprüfung bis zur Reklamation.",
    sec1Title: "Wie Projekte geprüft werden",
    sec1Desc: "Jede Anfrage durchläuft unsere automatische Qualitäts-Engine. Nur Anfragen mit einem Score von mindestens 60 Punkten werden an Betriebe weitergeleitet.",
    sec1Item1: "Telefonnummer wird verifiziert (+20 Punkte)",
    sec1Item2: "Budgetangabe vorhanden (+25 Punkte)",
    sec1Item3: "Projektbeschreibung geprüft (+10 Punkte)",
    sec1Item4: "Kontaktdaten vollständig (+10 Punkte)",
    sec2Title: "Wie Betriebe verifiziert werden",
    sec2Desc: "Unsere Betriebe durchlaufen einen mehrstufigen Verifizierungsprozess. Nur geprüfte Betriebe erhalten Projektanfragen.",
    sec2Item1: "Gewerbeanmeldung geprüft (Level 1)",
    sec2Item2: "Betriebshaftpflicht verifiziert (Level 2)",
    sec2Item3: "Bonitätsprüfung bestanden (Level 3)",
    sec2Item4: "Identitätsprüfung abgeschlossen (Level 3)",
    sec3Title: "Wie Abrechnung funktioniert",
    sec3Desc: "Transparente, planbare Kosten. Keine versteckten Gebühren, keine Provisionen auf Aufträge.",
    sec3Item1: "Feste Preise pro Kontakt – vorab sichtbar",
    sec3Item2: "Flexible Modelle: Flex, Professional, Premium",
    sec3Item3: "Monatliche Abrechnung, jederzeit kündbar",
    sec4Title: "Wie Reklamation funktioniert",
    sec4Desc: "Fairer Prozess bei berechtigten Beschwerden. Erstattung innerhalb von 72 Stunden.",
    sec4Item1: "Reklamation direkt im Dashboard einreichen",
    sec4Item2: "Gründe: Nicht erreichbar, falsches Gewerk, kein echtes Projekt",
    sec4Item3: "Berechtigte Reklamationen werden sofort erstattet",
    ctaTitle: "Haben Sie noch Fragen?",
    ctaDesc: "Kontaktieren Sie uns oder starten Sie direkt – wir stehen für Transparenz und Fairness.",
    ctaClientBtn: "Projekt professionell starten",
    ctaProviderBtn: "Mehr qualifizierte Projekte sichern",
  },
};

export default de;
